import { get, post, del, put, upload, uploadPut } from '@api/request';
import { findSketchDetailName } from '@modules/sketch/pages/create/util/findSketchDetailName';
import { sketchDefaultData } from '@modules/sketch/pages/create/constants';

export const fetchCyclomediaBetterView = async (
  { gamaService },
  authenticationToken,
  { pid },
) => {
  const url = `${gamaService}/gama/betterview/${pid}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPropertyTaxRates = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/taxrates`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const sketchSearch = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketch/search`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const linkSketch = async (
  { appraisalService, sketchService },
  authenticationToken,
  { payload },
) => {
  if (
    payload.improvement.sketchID !== 0 &&
    payload.improvement.sketchID !== null
  ) {
    let alreadyLinked = {
      results: {
        error: true,
        message:
          'This improvement already has a sketch.  If you wish to override the sketch on file, please delete that sketch record first and return here.',
      },
    };
    return alreadyLinked;
  }
  let improvementDetailsFetch = await fetchPropertyImprovementDetails(
    { appraisalService },
    authenticationToken,
    { improvementId: payload.improvementId },
  );
  let improvementDetails = improvementDetailsFetch
    ? improvementDetailsFetch.results
    : [];
  let sketchDataFetch = await editSketch(
    { sketchService },
    authenticationToken,
    {
      payload: payload.sketchID,
    },
  );
  let sketchData = sketchDataFetch.results[0];
  let match = true;
  if (
    sketchData.sketchCommands[2].detailList.length === improvementDetails.length
  ) {
    for (let x = 0; x < improvementDetails.length; x++) {
      if (
        improvementDetails[x].imprvDetailType !==
        findSketchDetailName(sketchData.sketchCommands[2].detailList[x])
      ) {
        match = false;
      }
    }
  } else {
    match = false;
  }
  if (!match) {
    // error: improvement details not the same
    let body = {
      results: {
        error: true,
        message:
          'Sketch link failed. Improvement details need to be the same name and in the same order in the improvement and sketch record.',
      },
    };
    return body;
  } else {
    let modifier = {
      improvement: payload.improvement,
      improvementDetails: improvementDetails,
    };
    let sketchPayload = {
      sketchCommands: sketchData.sketchCommands,
      description: `PID ${payload.pid} ${'\u00A0'}|${'\u00A0'} IMP ID ${
        payload.improvementId
      }`,
      address: payload.address,
      improvementID: payload.improvementId,
      sketchID: sketchData.sketchID,
      lastUpdate: sketchData.updateDt,
    };
    let table = CalculateDetailsProperties(sketchData.sketchCommands).table;

    await updateAppraisalSketch(
      { appraisalService, sketchService },
      authenticationToken,
      {
        payload: sketchPayload,
        modifier,
        table,
      },
    );
    // link the sketch
  }

  return sketchDataFetch;
};

function CalculateDetailsProperties(entities) {
  const result = {
    sketchCommands: entities,
    table: [],
  };
  for (let x = 1; x <= result.sketchCommands[2].detailList.length; x++) {
    let nodes = 0;
    let area = 0;
    const improvementDetail = result.sketchCommands[2].detailList[x - 1];
    let arcs = 0;
    let perimeter = 0;
    const newRow = {};
    for (let y = 0; y < result.sketchCommands[0].details.length; y++) {
      if (result.sketchCommands[0].details[y].detailInfo === x) {
        if (result.sketchCommands[0].details[y].area) {
          if (result.sketchCommands[0].details[y].type === 'xgon') {
            nodes += result.sketchCommands[0].details[y].numSides;
          } else if (result.sketchCommands[0].details[y].type !== 'circle') {
            nodes =
              nodes +
              result.sketchCommands[0].details[y].coordinates.length -
              1;
          }
        } else {
          nodes += result.sketchCommands[0].details[y].coordinates.length;
        }
        area += result.sketchCommands[0].details[y].area;
        perimeter += result.sketchCommands[0].details[y].perimeter;
        for (
          let z = 0;
          z < result.sketchCommands[0].details[y].arcData.length;
          z++
        ) {
          if (result.sketchCommands[0].details[y].arcData[z]) {
            arcs++;
          }
        }
      }
    }
    newRow.improvementDetail = improvementDetail;
    newRow.area = (area / 100).toFixed(1);
    newRow.perimeter = (perimeter / 10).toFixed(1);
    newRow.nodes = nodes;
    newRow.arcs = arcs;
    result.table.push(newRow);
  }
  return result;
}

export const updateAppraisalSketch = async (
  { sketchService, appraisalService },
  authenticationToken,
  { payload, modifier, table },
) => {
  const url = `${sketchService}/sketchservice/sketch/${payload.sketchID}`;
  const data1 = await put(authenticationToken, url, payload);
  let data = {
    sketchID: data1.body.results[0].sketchID,
    lastUpdate: modifier.improvement.updateDt,
  };
  let improvementId = modifier.improvement.pImprovementID;
  await updateSketchId({ appraisalService }, authenticationToken, {
    improvementId,
    data,
  });
  let detailId = null;
  for (let x = 0; x < table.length; x++) {
    data = {
      sketchArea: table[x].area,
      perimeter: table[x].perimeter,
      arcs: table[x].arcs,
      nodes: table[x].nodes,
      lastUpdate: modifier.improvementDetails[x].updateDt,
    };
    detailId = modifier.improvementDetails[x].pDetailID;
    await updateImprovementDetailSketchFields(
      { appraisalService },
      authenticationToken,
      {
        detailId,
        data,
      },
    );
  }
  return data1;
};

const updateSketchId = async (
  { appraisalService },
  authenticationToken,
  { improvementId, data },
) => {
  const url = `${appraisalService}/appraisal/improvement/${improvementId}/sketch`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

const updateImprovementDetailSketchFields = async (
  { appraisalService },
  authenticationToken,
  { detailId, data },
) => {
  const url = `${appraisalService}/appraisal/improvementdetail/${detailId}/sketch`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const editSketch = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  if (payload === undefined) {
    const body = {
      results: [JSON.parse(JSON.stringify(sketchDefaultData))],
    };
    return body;
  }
  const url = `${sketchService}/sketchservice/sketch/${payload}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function fetchSearchConfig(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/config/propertysearch`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSearchResultsConfig(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/config/propertysearchresults`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function searchProperty(
  { appraisalService },
  authenticationToken,
  {
    pageSize,
    page,
    sortField,
    sortDirection,
    sortField1,
    sortDirection1,
    sortField2,
    sortDirection2,
    sortField3,
    sortDirection3,
    filterModel,
    payload,
  },
) {
  let url = `${appraisalService}/appraisal/property/search?page=${page}&pageSize=${pageSize}`;

  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }

  if (sortField1 && sortDirection1) {
    url += `&sortField1=${sortField1}&sortDirection1=${sortDirection1}`;
  }

  if (sortField2 && sortDirection2) {
    url += `&sortField2=${sortField2}&sortDirection2=${sortDirection2}`;
  }

  if (sortField3 && sortDirection3) {
    url += `&sortField3=${sortField3}&sortDirection3=${sortDirection3}`;
  }

  if (filterModel && Object.keys(filterModel).length >= 0) {
    Object.keys(filterModel).forEach((filter) => {
      url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
    });
  }

  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function searchPropertyStandalone(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  let url = `${appraisalService}/appraisal/property/search`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function searchPropertyExport(
  { appraisalService },
  authenticationToken,
  {
    sortField,
    sortDirection,
    sortField1,
    sortDirection1,
    sortField2,
    sortDirection2,
    sortField3,
    sortDirection3,
    filterModel,
    payload,
  },
) {
  let url = `${appraisalService}/appraisal/property/search?`;

  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }

  if (sortField1 && sortDirection1) {
    url += `&sortField1=${sortField1}&sortDirection1=${sortDirection1}`;
  }

  if (sortField2 && sortDirection2) {
    url += `&sortField2=${sortField2}&sortDirection2=${sortDirection2}`;
  }

  if (sortField3 && sortDirection3) {
    url += `&sortField3=${sortField3}&sortDirection3=${sortDirection3}`;
  }

  if (filterModel && Object.keys(filterModel).length >= 0) {
    Object.keys(filterModel).forEach((filter) => {
      url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
    });
  }

  const { body } = await post(authenticationToken, url, payload, {
    outputType: 'bytearray',
  });

  let blob = new Blob([body], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = 'export.xlsx';

  link.click();
  window.URL.revokeObjectURL(link.href);
}

export async function fetchAppraisalConfiguration(
  { appraisalService },
  authenticationToken,
) {
  let url = `${appraisalService}/appraisal/configurations`;

  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchConfigurationByName(
  { appraisalService },
  authenticationToken,
  { configurationName },
) {
  let url = `${appraisalService}/appraisal/configuration/fetchbyname/${configurationName}`;

  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyFull(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  let url = `${appraisalService}/appraisal/property/search`;

  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchPropertyFullMass(
  { appraisalService },
  authenticationToken,
  { propertyList, pYear },
) {
  let result = [];
  let data = null;
  if (propertyList && propertyList.length) {
    let payload = null;
    payload = {
      AccountStatus: {
        operator: '=',
        value: 'All',
      },
      pid: {
        operator: 'in',
        value: propertyList,
      },
      pYear: {
        operator: '=',
        value: pYear,
      },
    };
    data = await fetchPropertyFull({ appraisalService }, authenticationToken, {
      payload,
    });
    if (data && data.results && data.results[0]) {
      let found = false;
      for (let x = 0; x < propertyList.length; x++) {
        found = false;
        for (let y = 0; y < data.results.length; y++) {
          if (propertyList[x] === String(data.results[y].pid)) {
            found = true;
            result[x] = {
              ...data.results[y],
              inputStatus:
                data.results[y].propertyStatus === 'Inactive'
                  ? 'inactive'
                  : 'valid',
            };
          }
        }
        if (!found) {
          result[x] = {
            pid: Number(propertyList[x]),
            pYear: payload.pYear.value,
            inputStatus: 'invalid',
          };
        }
      }
    } else {
      for (let x = 0; x < propertyList.length; x++) {
        result[x] = {
          pid: Number(propertyList[x]),
          pYear: payload.pYear.value,
          inputStatus: 'invalid',
        };
      }
    }
  }
  return result;
}

// This is the same as search for now, but may change in the future
export async function lookupProperty(
  { appraisalService },
  authenticationToken,
  { pageSize, page, sortField, sortDirection, filterModel, payload },
) {
  let url = `${appraisalService}/appraisal/property/search?page=${page}&pageSize=${pageSize}`;

  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }

  if (filterModel && Object.keys(filterModel).length >= 0) {
    Object.keys(filterModel).forEach((filter) => {
      url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
    });
  }

  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchPropertySearch(
  { appealsService },
  authenticationToken,
  { pId, pYear },
) {
  const url = `${appealsService}/prodigyappeals/property/${pId}/${pYear}/search`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertySearchMulti(
  { appealsService },
  authenticationToken,
  { payload, pYear },
) {
  const url = `${appealsService}/prodigyappeals/property/${pYear}/search`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchProperty(
  { appraisalService },
  authenticationToken,
  { propertyId, selectedYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${selectedYear}/${pVersion}/${pRollCorr}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyMenuprofiles(
  { appraisalService },
  authenticationToken,
  { propertyId, selectedYear, pVersion = 0, pRollCorr = 0 },
) {
  // This API was used before which did not filter the menu profiles based on role
  // let url = `${appraisalService}/appraisal/screenconfiguration/menuprofiles`;
  // url += `?page=${page}&pageSize=${pageSize}`;
  // url += `?propertyId=${propertyId}`;

  const url = `${appraisalService}/appraisal/menuprofile/property/${propertyId}/${selectedYear}/${pVersion}/${pRollCorr}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertySubPage(
  { appraisalService },
  authenticationToken,
  { webpageId },
) {
  const url = `${appraisalService}/appraisal/page/${webpageId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addPropertyNote(
  { appraisalService },
  authenticationToken,
  { propertyId, data },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/notes`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchPropertyNotes(
  { appraisalService },
  authenticationToken,
  { propertyId, query },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/notes${
    query ? `?${query}` : ''
  }`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deletePropertyNote(
  { appraisalService },
  authenticationToken,
  { noteId },
) {
  const url = `${appraisalService}/appraisal/propertynote/${noteId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updatePropertyNote(
  { appraisalService },
  authenticationToken,
  { noteId, data },
) {
  const url = `${appraisalService}/appraisal/propertynote/${noteId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function updatePropertyNoteTags(
  { appraisalService },
  authenticationToken,
  { noteId, data },
) {
  const url = `${appraisalService}/appraisal/propertynote/${noteId}/tags`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function validateProperty(
  { appraisalService },
  authenticationToken,
  { propertyId, data },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/casscertification`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function updateProperty(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, data },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function updatePropertyPrimaryImage(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion, pRollCorr, data },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/primaryimageupdate`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function getPropertyInactiveReasons(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Property&name=Inactive Reason`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getPropertyReactivateReasons(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Property&name=Reactivate Reason`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function propertyInactivate(
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0, data },
) {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/inactivate`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function propertyReactivate(
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0, data },
) {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/reactivate`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function createProperty(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/propertys`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchPropertySummary(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/summary`;
  let { body } = await get(authenticationToken, url);
  return body;
}

export async function updateRenderedValue(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, payload },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/propertymarketvaluerendered`;
  let { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchRenderedValue(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/propertymarketvalue`;
  let { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchOwnerValueSummary(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/ownervaluesummary`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyMobileHomes(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/mobilehomes`;
  let { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyLegalDescription(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/legaldescription`;
  let { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePropertyLegalDescription(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, data },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/legaldescription`;
  const { updateDt, ...newData } = data;
  newData.lastUpdate = updateDt;
  const { body } = await put(authenticationToken, url, { ...newData });
  return body;
}

export async function fetchPropertyMineralLegalDescription(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/legaldescriptionmineral`;
  let { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePropertyMineralLegalDescription(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, data },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/legaldescriptionmineral`;
  const { updateDt, ...newData } = data;
  newData.lastUpdate = updateDt;
  const { body } = await put(authenticationToken, url, { ...newData });
  return body;
}

export async function fetchAutoCompleteMineralLegal(
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0, data },
) {
  const url = `${appraisalService}/appraisal/autocompletelegal/${pid}/${pYear}/${pVersion}/${pRollCorr}`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchPropertyIdentification(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/identification`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePropertyIdentification(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, data },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/identification`;
  const { updateDt, ...newData } = data;
  newData.lastUpdate = updateDt;
  const { body } = await put(authenticationToken, url, { ...newData });
  return body;
}

export async function fetchPropertySummaryBPP(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/summarybpp`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getDropdownValues(
  services,
  authenticationToken,
  { endpoint, year, service, payload, removeNulls },
) {
  let url = `${
    service ? services[service] : services.appraisalService
  }${endpoint}`;
  const queryPrefix = url.includes('?') ? '&' : '?';
  url = year ? `${url}${queryPrefix}year=${year}` : url;
  if (payload) {
    const { body } = await post(authenticationToken, url, payload);
    return body;
  }
  const { body } = await get(authenticationToken, url);
  if (removeNulls && body && body.results && body.results.length) {
    body.results = body.results.filter((r) => r.codeName);
  }
  return body;
}

export async function fetchPropertyPrimarySitus(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/primarysitus`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyPrimaryOwner(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/primaryowner`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyTaxingUnits(
  { assessmentService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${assessmentService}/assessment/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/taxingunitsummary`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyAllSitus(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/situsaddress`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createPropertySitus(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, data },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/situsaddress`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function deletePropertySitus(
  { appraisalService },
  authenticationToken,
  { situsId },
) {
  const url = `${appraisalService}/appraisal/situsaddress/${situsId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function setPropertySitusPrimary(
  { appraisalService },
  authenticationToken,
  { situsId },
) {
  const url = `${appraisalService}/appraisal/situsaddress/${situsId}/primary`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function updatePropertySitus(
  { appraisalService },
  authenticationToken,
  { situsId, data },
) {
  const url = `${appraisalService}/appraisal/situsaddress/${situsId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function fetchValuationTypes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/valuationtypes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchImprovementTypes(
  { appraisalService },
  authenticationToken,
  { pYear },
) {
  const url = `${appraisalService}/appraisal/codes?type=Improvement&name=Type&year=${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyValuations(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/propertyvaluations`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePropertyMarketIncludePresentation(
  { appraisalService },
  authenticationToken,
  { pMarketID },
) {
  const url = `${appraisalService}/appraisal/marketapproach/${pMarketID}/includepresentation`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function updatePropertyMarketGridComment(
  { appraisalService },
  authenticationToken,
  { pMarketID, data },
) {
  const url = `${appraisalService}/appraisal/marketapproach/${pMarketID}/gridcomment`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function updatePropertyEquityIncludePresentation(
  { appraisalService },
  authenticationToken,
  { pEquityID },
) {
  const url = `${appraisalService}/appraisal/equityapproach/${pEquityID}/includepresentation`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function updatePropertyEquityGridComment(
  { appraisalService },
  authenticationToken,
  { pEquityID, data },
) {
  const url = `${appraisalService}/appraisal/equityapproach/${pEquityID}/gridcomment`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function createPropertyValuation(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, data },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/propertyvaluations`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function createPropertyEconomicValuation(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/economicunitfromproperty`;
  const payload = {
    pID: propertyId,
    pYear,
    pVersion,
    pRollCorr,
  };
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updatePropertyValuation(
  { appraisalService },
  authenticationToken,
  { pValuationId, data },
) {
  const url = `${appraisalService}/appraisal/valuation/${pValuationId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deletePropertyValuation(
  { appraisalService },
  authenticationToken,
  { valuationId },
) {
  const url = `${appraisalService}/appraisal/valuation/${valuationId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function setPrimaryValuation(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, pValuationId },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/valuations/setprimary`;
  const { body } = await put(authenticationToken, url, {
    pValuationID: pValuationId,
  });
  return body;
}

export async function distributePropertyValuation(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, payload },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/distribute`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchPropertyImprovements(
  { appraisalService },
  authenticationToken,
  { costId },
) {
  const url = `${appraisalService}/appraisal/costapproach/${costId}/improvements`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createPropertyImprovement(
  { appraisalService },
  authenticationToken,
  { costId, data },
) {
  const url = `${appraisalService}/appraisal/costapproach/${costId}/improvements`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function updatePropertyImprovement(
  { appraisalService },
  authenticationToken,
  { improvementId, data },
) {
  const url = `${appraisalService}/appraisal/improvement/${improvementId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deletePropertyImprovement(
  { appraisalService },
  authenticationToken,
  { improvementId, sketchData },
) {
  if (sketchData && sketchData.sketchID) {
    deleteImprovementSketch({ appraisalService }, authenticationToken, {
      sketchData,
    });
  }
  const url = `${appraisalService}/appraisal/improvement/${improvementId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

const deleteImprovementSketch = async (
  { sketchService },
  authenticationToken,
  { sketchData },
) => {
  const url = `${sketchService}/sketchservice/sketch/${sketchData.sketchID}`;
  del(authenticationToken, url);
};

export async function fetchAutoCompleteLegal(
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0, data },
) {
  const url = `${appraisalService}/appraisal/autocompletelegal/${pid}/${pYear}/${pVersion}/${pRollCorr}`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchPropertyImprovementDetails(
  { appraisalService },
  authenticationToken,
  { improvementId },
) {
  const url = `${appraisalService}/appraisal/improvement/${improvementId}/improvementdetails`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createPropertyImprovementDetail(
  { appraisalService },
  authenticationToken,
  { improvementId, data },
) {
  // if (sketchData && sketchData.sketchID) {
  //   updateImprovementSketch({appraisalService}, authenticationToken, { sketchData });
  // }
  const url = `${appraisalService}/appraisal/improvement/${improvementId}/improvementdetails`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function updatePropertyImprovementDetail(
  { appraisalService, sketchService },
  authenticationToken,
  { improvementDetailId, data, sketchData },
) {
  let sketchFieldData = null;
  if (
    data.perimeter ||
    data.perimeterSource ||
    data.sketchPerimeter ||
    data.manualPerimeter
  ) {
    sketchFieldData = await updateImprovementDetailSketchFields(
      { appraisalService },
      authenticationToken,
      {
        detailId: improvementDetailId,
        data: {
          ...data,
          perimeter:
            data.perimeterSource === 'M'
              ? data.manualPerimeter
              : data.sketchPerimeter,
          perimeterSource: data.perimeterSource ? data.perimeterSource : 'S',
        },
      },
    );
  }
  if (sketchData && sketchData.sketchID) {
    updateImprovementSketch({ sketchService }, authenticationToken, {
      sketchData,
    });
  }
  if (
    sketchFieldData &&
    sketchFieldData.results &&
    sketchFieldData.results[0]
  ) {
    data.lastUpdate = sketchFieldData.results[0].updateDt;
  }
  const url = `${appraisalService}/appraisal/improvementdetail/${improvementDetailId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deletePropertyImprovementDetail(
  { appraisalService, sketchService },
  authenticationToken,
  { improvementDetailId, sketchData },
) {
  if (sketchData && sketchData.sketchID) {
    updateImprovementSketch({ sketchService }, authenticationToken, {
      sketchData,
    });
  }
  const url = `${appraisalService}/appraisal/improvementdetail/${improvementDetailId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

const updateImprovementSketch = async (
  { sketchService },
  authenticationToken,
  { sketchData },
) => {
  const sketchSettingsUrl = `${sketchService}/sketchservice/sketch/settings`;
  const settings = await get(authenticationToken, sketchSettingsUrl);
  const url = `${sketchService}/sketchservice/sketch/${sketchData.sketchID}`;
  const data1 = await get(authenticationToken, url);
  let entities = JSON.parse(
    JSON.stringify(data1.body.results[0].sketchCommands),
  );
  let newDetailName = '';
  if (sketchData.duplicate) {
    entities[2].detailList.push(sketchData.detail.type);
    entities[2].detailLayers.push(null);
  } else if (sketchData.create) {
    newDetailName =
      settings &&
      settings.body &&
      settings.body.results &&
      settings.body.results[0] &&
      settings.body.results[0].settings &&
      settings.body.results[0].settings.showClass
        ? `${sketchData.detail.imprvDetailType}/${sketchData.detail.class}`
        : sketchData.detail.imprvDetailType;
    entities[2].detailList.push(newDetailName);
    entities[2].detailLayers.push(null);
  } else if (sketchData.update && !isNaN(sketchData.detailIndex)) {
    newDetailName =
      settings &&
      settings.body &&
      settings.body.results &&
      settings.body.results[0] &&
      settings.body.results[0].settings &&
      settings.body.results[0].settings.showClass
        ? `${sketchData.detail.imprvDetailType}/${sketchData.detail.class}`
        : sketchData.detail.imprvDetailType;
    entities[2].detailList[sketchData.detailIndex] = newDetailName;
  } else {
    let details = [];
    for (let x = 0; x < entities[0].details.length; x++) {
      if (
        entities[0].details[x].detailInfo !== sketchData.detailIndex &&
        sketchData.detailIndex !== 0
      ) {
        if (entities[0].details[x].detailInfo > sketchData.detailIndex) {
          entities[0].details[x].detailInfo =
            entities[0].details[x].detailInfo - 1;
        }
        details.push(entities[0].details[x]);
      }
    }
    entities[0].details = details;
    entities[2].detailList.splice(sketchData.detailIndex - 1, 1);
    entities[2].detailLayers.splice(sketchData.detailIndex - 1, 1);
  }
  let payload = {
    sketchCommands: entities,
    description: data1.body.results[0].description,
    address: data1.body.results[0].address,
    sketchID: data1.body.results[0].sketchID,
    improvementID: data1.body.results[0].improvementID,
    lastUpdate: data1.body.results[0].updateDt,
  };
  saveImprovementSketch({ sketchService }, authenticationToken, {
    payload,
  });
};

const saveImprovementSketch = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketch/${payload.sketchID}`;
  await put(authenticationToken, url, payload);
};

export async function fetchImprovementDetailFeatures(
  { appraisalService },
  authenticationToken,
  { improvementDetailId },
) {
  const url = `${appraisalService}/appraisal/improvementdetail/${improvementDetailId}/improvementdetailfeatures`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function saveImprovementDetailFeatures(
  { appraisalService },
  authenticationToken,
  { improvementDetailId, data },
) {
  const url = `${appraisalService}/appraisal/improvementdetail/${improvementDetailId}/improvementdetailfeatures`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchPropertyLand(
  { appraisalService },
  authenticationToken,
  { costId },
) {
  const url = `${appraisalService}/appraisal/costapproach/${costId}/land`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createPropertyLand(
  { appraisalService },
  authenticationToken,
  { costId, data },
) {
  const url = `${appraisalService}/appraisal/costapproach/${costId}/land`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function updatePropertyLand(
  { appraisalService },
  authenticationToken,
  { landId, data },
) {
  const url = `${appraisalService}/appraisal/land/${landId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deletePropertyLand(
  { appraisalService },
  authenticationToken,
  { landId },
) {
  const url = `${appraisalService}/appraisal/land/${landId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchSubcomponentConfig(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, subcomponentType },
) {
  const url =
    `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/subcomponent/property/` +
    `${subcomponentType}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchBuilderPlanSubcomponentConfig(
  { appraisalService },
  authenticationToken,
  { subcomponentType },
) {
  const url = `${appraisalService}/appraisal/builderplan/subcomponent/property/${subcomponentType}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyOwners(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/accounts`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getPropertyBuilderAdjustments(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/builderadjustment`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePropertyBuilderAdjustments(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, payload },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/builderadjustment`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchAllPropertyTaxingUnits(
  { assessmentService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${assessmentService}/assessment/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/taxingunits`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createPropertyTaxingUnit(
  { assessmentService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, payload },
) {
  const url = `${assessmentService}/assessment/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/taxingunits`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updatePropertyTaxingUnit(
  { assessmentService },
  authenticationToken,
  { taxingUnitId, payload },
) {
  const url = `${assessmentService}/assessment/propertytaxingunit/${taxingUnitId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchDeannexations(
  { assessmentService },
  authenticationToken,
  { pID, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${assessmentService}/assessment/propertytaxingunit/${pID}/${pYear}/${pVersion}/${pRollCorr}/deannexations`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteDeannexation(
  { assessmentService },
  authenticationToken,
  { pDeannexID },
) {
  const url = `${assessmentService}/assessment/propertytaxingunitdeannexation/${pDeannexID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function deletePropertyTaxingUnit(
  { assessmentService },
  authenticationToken,
  { taxingUnitId, payload },
) {
  const url = `${assessmentService}/assessment/propertytaxingunit/${taxingUnitId}`;
  const { body } = await del(authenticationToken, url, payload);
  return body;
}

export async function createPropertyLandNote(
  { appraisalService },
  authenticationToken,
  { landId, data },
) {
  const url = `${appraisalService}/appraisal/land/${landId}/landnotes`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchPropertyLandNotes(
  { appraisalService },
  authenticationToken,
  { landId },
) {
  const url = `${appraisalService}/appraisal/land/${landId}/landnotes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePropertyLandNote(
  { appraisalService },
  authenticationToken,
  { noteId, data },
) {
  const url = `${appraisalService}/appraisal/landnote/${noteId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deletePropertyLandNote(
  { appraisalService },
  authenticationToken,
  { noteId },
) {
  const url = `${appraisalService}/appraisal/landnote/${noteId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchPropertyExemptions(
  { assessmentService },
  authenticationToken,
  { propertyId, selectedYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${assessmentService}/assessment/property/${propertyId}/${selectedYear}/${pVersion}/${pRollCorr}/exemptions`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function generateGeoID(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/generategeoid`;
  const { body } = await put(authenticationToken, url, {});
  return body;
}

export async function fetchPropertyExemption(
  { assessmentService },
  authenticationToken,
  { pExemptionID },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemption/${pExemptionID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createPropertyExemption(
  { assessmentService },
  authenticationToken,
  { pAccountID, payload },
) {
  const url = `${assessmentService}/assessment/propertyaccount/${pAccountID}/exemptions`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deletePropertyExemption(
  { assessmentService },
  authenticationToken,
  { pExemptionID },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemption/${pExemptionID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updatePropertyExemption(
  { assessmentService },
  authenticationToken,
  { pExemptionID, payload },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemption/${pExemptionID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchExemptionCode(
  { assessmentService },
  authenticationToken,
  { exemptionCode, pYear },
) {
  const url = `${assessmentService}/assessment/exemption/${exemptionCode}/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createImprovementAdjustment(
  { appraisalService },
  authenticationToken,
  { improvementId, data },
) {
  const url = `${appraisalService}/appraisal/improvement/${improvementId}/adjustments`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchImprovementAdjustTypes(
  { appraisalService },
  authenticationToken,
  { pYear },
) {
  const url = `${appraisalService}/appraisal/models/adjustments/improvement/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchImprovementAdjustments(
  { appraisalService },
  authenticationToken,
  { improvementId },
) {
  const url = `${appraisalService}/appraisal/improvement/${improvementId}/adjustments`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateImprovementAdjustment(
  { appraisalService },
  authenticationToken,
  { pAdjustmentId, data },
) {
  const url = `${appraisalService}/appraisal/improvementadjustment/${pAdjustmentId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deleteImprovementAdjustment(
  { appraisalService },
  authenticationToken,
  { pAdjustmentId },
) {
  const url = `${appraisalService}/appraisal/improvementadjustment/${pAdjustmentId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function createLandAdjustment(
  { appraisalService },
  authenticationToken,
  { landId, data },
) {
  const url = `${appraisalService}/appraisal/land/${landId}/adjustments`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchLandAdjustTypes(
  { appraisalService },
  authenticationToken,
  { pYear },
) {
  const url = `${appraisalService}/appraisal/models/adjustments/land/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchLandAdjustments(
  { appraisalService },
  authenticationToken,
  { landId },
) {
  const url = `${appraisalService}/appraisal/land/${landId}/adjustments`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateLandAdjustment(
  { appraisalService },
  authenticationToken,
  { pAdjustmentId, data },
) {
  const url = `${appraisalService}/appraisal/landadjustment/${pAdjustmentId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deleteLandAdjustment(
  { appraisalService },
  authenticationToken,
  { pAdjustmentId },
) {
  const url = `${appraisalService}/appraisal/landadjustment/${pAdjustmentId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function createImprvDetailAdjustment(
  { appraisalService },
  authenticationToken,
  { pDetailId, data },
) {
  const url = `${appraisalService}/appraisal/improvementdetail/${pDetailId}/adjustments`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchImprvDetailAdjustTypes(
  { appraisalService },
  authenticationToken,
  { pYear },
) {
  const url = `${appraisalService}/appraisal/models/adjustments/improvement/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchImprvDetailAdjustments(
  { appraisalService },
  authenticationToken,
  { pDetailId },
) {
  const url = `${appraisalService}/appraisal/improvementdetail/${pDetailId}/adjustments`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateImprvDetailAdjustment(
  { appraisalService },
  authenticationToken,
  { pAdjustmentId, data },
) {
  const url = `${appraisalService}/appraisal/improvementdetailadjustment/${pAdjustmentId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deleteImprvDetailAdjustment(
  { appraisalService },
  authenticationToken,
  { pAdjustmentId },
) {
  const url = `${appraisalService}/appraisal/improvementdetailadjustment/${pAdjustmentId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchImprovementInfluencer(
  { appraisalService },
  authenticationToken,
  { improvementId },
) {
  const url = `${appraisalService}/appraisal/improvement/${improvementId}/influencer`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateImprovementInfluencer(
  { appraisalService },
  authenticationToken,
  { improvementId, data },
) {
  const url = `${appraisalService}/appraisal/improvement/${improvementId}/influencer`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function fetchLandInfluencer(
  { appraisalService },
  authenticationToken,
  { landId },
) {
  const url = `${appraisalService}/appraisal/land/${landId}/influencer`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateLandInfluencer(
  { appraisalService },
  authenticationToken,
  { landId, data },
) {
  const url = `${appraisalService}/appraisal/land/${landId}/influencer`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function fetchPropertyMarketAreaModifiers(
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/modifiers`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchImprvDetailInfluencer(
  { appraisalService },
  authenticationToken,
  { pDetailId },
) {
  const url = `${appraisalService}/appraisal/improvementdetail/${pDetailId}/influencer`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateImprvDetailInfluencer(
  { appraisalService },
  authenticationToken,
  { pDetailId, data },
) {
  const url = `${appraisalService}/appraisal/improvementdetail/${pDetailId}/influencer`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function fetchPropertyHeader(
  { appraisalService },
  authenticationToken,
  { propertyId, selectedYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${selectedYear}/${pVersion}/${pRollCorr}/header`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function recalculateProperty(
  { recalculationService },
  authenticationToken,
  { propertyId, selectedYear, pVersion = 0, pRollCorr = 0 },
) {
  const url =
    `${recalculationService}/recalc/property/${propertyId}/${selectedYear}` +
    `/${pVersion}/${pRollCorr}`;
  const { body } = await post(authenticationToken, url, {});
  return body;
}

export async function fetchPropertySize(
  { appraisalService },
  authenticationToken,
  { propertyId, selectedYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${selectedYear}/${pVersion}/${pRollCorr}/propertysize`;
  const { body } = await get(authenticationToken, url);
  return body;
}

// export async function fetchPropertyExemptionCard(
//   {appraisalService},
//   authenticationToken,
//   { propertyId, selectedYear },
// ) {
//   const url = `${appraisalService}/assessment/property/${propertyId}/${selectedYear}/${pVersion}/${pRollCorr}/exemptioncard`;
//   const { body } = await get(authenticationToken, url);
//   return body;
// }

export async function fetchPropertyExemptionCard(
  { assessmentService },
  authenticationToken,
  { pAccountId },
) {
  const url = `${assessmentService}/assessment/propertyaccount/${pAccountId}/exemptioncard`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyValueSummary(
  { appraisalService },
  authenticationToken,
  { propertyId, selectedYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${selectedYear}/${pVersion}/${pRollCorr}/valuesummary`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchZestimate(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear = 2017, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/zillow/zestimate/${propertyId}/${pYear}/${pVersion}/${pRollCorr}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchZProperty(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear = 2017, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/zillow/zpropertydetails/${propertyId}/${pYear}/${pVersion}/${pRollCorr}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchZComps(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear = 2017, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/zillow/zcomps/${propertyId}/${pYear}/${pVersion}/${pRollCorr}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchZillowPropertyHeader(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/zillow/propertyheader/${propertyId}/${pYear}/${pVersion}/${pRollCorr}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

// Property Characteristics
export async function fetchPropertyCharacteristics(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/characteristics`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePropertyCharacteristics(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, data },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/characteristics`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function fetchPropertyEvents(
  { eventService },
  authenticationToken,
  { propertyId },
) {
  const url = `${eventService}/events/search`;
  const { body } = await post(authenticationToken, url, {
    objectID: `${propertyId}`,
    dataObject: 'property',
    returnEventPropertyOwners: 1,
  });
  return body;
}

export async function fetchApplicationEvents(
  { eventService },
  authenticationToken,
  { applicationID, page, pageSize },
) {
  const url = `${eventService}/events/search`;
  const { body } = await post(authenticationToken, url, {
    applicationID: `${applicationID}`,
    dataObject: 'application',
    page,
    pageSize,
  });
  return body;
}

export async function deleteApplicationEvents(
  { eventService },
  authenticationToken,
  { eventID },
) {
  const url = `${eventService}/events/pevent/${eventID}`;
  const { body } = await del(authenticationToken, url, {
    eventData: ['event', 'Data', 'update'],
    lastUpdate: null,
  });
  return body;
}

export async function deletePropertyEvent(
  { appraisalService },
  authenticationToken,
  { eventID },
) {
  const url = `${appraisalService}/appraisal/pEvent/${eventID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchPropertyMassCreate(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/property/masscreate`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchIndividualMassCreate(
  { appraisalService },
  authenticationToken,
  { id },
) {
  const url = `${appraisalService}/appraisal/property/masscreate/${id}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createPropertyMassCreate(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/property/masscreate`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchAllMassCreateSettings(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/property/masscreatesettings`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassCreateSetting(
  { appraisalService },
  authenticationToken,
  { id },
) {
  const url = `${appraisalService}/appraisal/property/masscreatesetting/${id}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteMassCreateSettings(
  { appraisalService },
  authenticationToken,
  { id },
) {
  const url = `${appraisalService}/appraisal/property/masscreatesetting/${id}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchAvailableMassCreateSettingPropTypes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/property/masscreatesettings/availableproptypes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addMassCreateSetting(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/property/masscreatesettings`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function updateMassCreateSetting(
  { appraisalService },
  authenticationToken,
  { id, pageId, lastUpdate },
) {
  const url = `${appraisalService}/appraisal/property/masscreatesetting/${id}`;
  const { body } = await put(authenticationToken, url, {
    pageID: pageId,
    lastUpdate,
  });
  return body;
}

export async function fetchSplitMergeHistory(
  { appraisalService },
  authenticationToken,
  { pid },
) {
  const url = `${appraisalService}/appraisal/property/${pid}/splitmergehistory`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassCreatePropertyPage(
  { appraisalService },
  authenticationToken,
  { propType },
) {
  const url = `${appraisalService}/appraisal/property/masscreatesettings/proptype/${propType}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createMassCreatePrepData(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/property/masscreate/prepdata`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function getMassCreateLegalDesc(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/property/masscreate/prepdatalegal`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function massCreateProperties(
  { appraisalService },
  authenticationToken,
  { id, properties },
) {
  const url = `${appraisalService}/appraisal/property/masscreate/${id}/createproperty`;
  const { body } = await post(authenticationToken, url, properties);
  return body;
}

export async function finalizeMassCreateRun(
  { appraisalService },
  authenticationToken,
  { id },
) {
  const url = `${appraisalService}/appraisal/property/masscreate/${id}/finalize`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function deleteMassCreateRun(
  { appraisalService },
  authenticationToken,
  { id },
) {
  const url = `${appraisalService}/appraisal/property/masscreate/${id}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchMassCreateProperties(
  { appraisalService },
  authenticationToken,
  { id },
) {
  const url = `${appraisalService}/appraisal/property/masscreate/${id}/properties`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePropertyExemptionReset(
  { appraisalService },
  authenticationToken,
  { propertyId, selectedYear, pVersion = 0, pRollCorr = 0, payload },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${selectedYear}/${pVersion}/${pRollCorr}/exemptionreset`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function updatePropertyTaxDeferral(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, payload },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/taxdeferral`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchPropertyTaxDeferral(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/taxdeferral`;
  const { body } = await get(authenticationToken, url);
  return body;
}

// Walkthrough Settings
export async function postWalkthroughSettings(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/walkthrusettings`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchAllWalkthroughSettings(
  { appraisalService },
  authenticationToken,
  { type },
) {
  const url = `${appraisalService}/appraisal/walkthrusettings?walkthruType=${type}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteWalkthroughSetting(
  { appraisalService },
  authenticationToken,
  { id },
) {
  const url = `${appraisalService}/appraisal/walkthrusetting/${id}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateWalkthroughSetting(
  { appraisalService },
  authenticationToken,
  { id, data },
) {
  const url = `${appraisalService}/appraisal/walkthrusetting/${id}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function fetchAvailablePropertyCreateSettingPropTypes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/walkthrusetting/createproperty/availablepropertytypes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

// ***

export async function createPropertyMerge(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/propertymerge`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function uploadPropertyMergeFile(
  { appraisalService },
  authenticationToken,
  { mergeId, payload },
) {
  const url = `${appraisalService}/appraisal/propertymerge/${mergeId}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function fetchPropertyMergeToOwnerListing(
  { appraisalService },
  authenticationToken,
  { id },
) {
  const url = `${appraisalService}/appraisal/propertymerge/${id}/mergetopropertyowners`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyMergeFromOwnerListing(
  { appraisalService },
  authenticationToken,
  { id },
) {
  const url = `${appraisalService}/appraisal/propertymerge/${id}/mergefrompropertyowners`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createPropertySplit(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/propertysplit`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export const updateLegalAcreage = async (
  { appraisalService },
  authenticationToken,
  { pID, pYear, pVersion = 0, pRollCorr = 0, data },
) => {
  const url = `${appraisalService}/appraisal/property/${pID}/${pYear}/${pVersion}/${pRollCorr}/updatelegalacreage`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const updateOwnershipPercent = async (
  { appraisalService },
  authenticationToken,
  { pID, pYear, pVersion = 0, pRollCorr = 0, data },
) => {
  const url = `${appraisalService}/appraisal/property/${pID}/${pYear}/${pVersion}/${pRollCorr}/updateownerpercent`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const getSplitReasons = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codes?type=Split&name=Reason`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function fetchSplitMergeHistoryDeedInfo(
  { appraisalService },
  authenticationToken,
  { transId },
) {
  const url = `${appraisalService}/appraisal/splitmergehistory/${transId}/deedinfo`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateSplitMergeHistoryChildren(
  { appraisalService },
  authenticationToken,
  { transId },
) {
  const url = `${appraisalService}/appraisal/splitmergehistory/${transId}/updatechildren`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function fetchSplitMergeHistorySummary(
  { appraisalService },
  authenticationToken,
  { transId },
) {
  const url = `${appraisalService}/appraisal/splitmergehistory/${transId}/summary`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createSingleProperty(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url1 = `${appraisalService}/appraisal/property/create`;
  const create = await post(authenticationToken, url1, data);
  const { pid, pYear, pVersion = 0, pRollCorr = 0 } = create.body.results[0];
  const url2 = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/activate`;
  const activate = await put(authenticationToken, url2);
  return activate.body;
}

export async function deleteSingleProperty(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/delete`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export const fetchApplications = async (
  { assessmentService },
  authenticationToken,
  { propertyId },
) => {
  const url = `${assessmentService}/assessment/property/${propertyId}/applications`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchApplication = async (
  { assessmentService },
  authenticationToken,
  { applicationId },
) => {
  const url = `${assessmentService}/assessment/propertyapplication/${applicationId}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchApplicationExemptions = async (
  { assessmentService },
  authenticationToken,
  { applicationId },
) => {
  const url = `${assessmentService}/assessment/propertyapplication/${applicationId}/exemptions`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const deleteApplication = async (
  { assessmentService },
  authenticationToken,
  { applicationId },
) => {
  const url = `${assessmentService}/assessment/propertyapplication/${applicationId}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchApplicationType = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codes?type=Application&name=Application Type`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchApplicationStatus = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codes?type=Application&name=Application Status`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchApplicationOwners = async (
  { assessmentService },
  authenticationToken,
  { propertyId },
) => {
  const url = `${assessmentService}/assessment/property/${propertyId}/applicationcurrentowners`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchApplicationIDType = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codes?type=Application&name=ID Type`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createApplication = async (
  { assessmentService },
  authenticationToken,
  { payload },
) => {
  const url = `${assessmentService}/assessment/propertyapplications`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateApplication = async (
  { assessmentService },
  authenticationToken,
  { payload },
) => {
  const url = `${assessmentService}/assessment/propertyapplication/${payload.applicationID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const completeApplication = async (
  { assessmentService },
  authenticationToken,
  { applicationId, payload },
) => {
  const url = `${assessmentService}/assessment/propertyapplication/${applicationId}/complete`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const completeApplicationMultiYear = async (
  { assessmentService },
  authenticationToken,
  { applicationId, payload },
) => {
  const url = `${assessmentService}/assessment/propertyapplication/${applicationId}/completemultiyear`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchExemptionCodefiles = async (
  { assessmentService },
  authenticationToken,
  { pYear },
) => {
  const url = `${assessmentService}/assessment/exemptions/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchApplicationRollCorrectionCodes = async (
  { assessmentService },
  authenticationToken,
) => {
  const url = `${assessmentService}/appraisal/configuration/fetchbyname/propertyApplicationRollCorrectionExemption`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchApplicationPropertyList = async (
  { assessmentService },
  authenticationToken,
  { applicationId },
) => {
  const url = `${assessmentService}/assessment/propertyapplication/${applicationId}/propertylist`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchExemptionYears = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/allyears`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createExemption = async (
  { assessmentService },
  authenticationToken,
  { payload, applicationID },
) => {
  const url = `${assessmentService}/assessment/propertyapplication/${applicationID}/exemptions`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateExemption = async (
  { assessmentService },
  authenticationToken,
  { payload },
) => {
  const url = `${assessmentService}/assessment/propertyapplicationexemption/${payload.applicationExemptionID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteExemption = async (
  { assessmentService },
  authenticationToken,
  { applicationExemptionID },
) => {
  const url = `${assessmentService}/assessment/propertyapplicationexemption/${applicationExemptionID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const denyExemption = async (
  { assessmentService },
  authenticationToken,
  { payload, applicationExemptionID },
) => {
  const url = `${assessmentService}/assessment/propertyapplicationexemption/${applicationExemptionID}/deny`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const approveExemption = async (
  { assessmentService },
  authenticationToken,
  { payload, applicationExemptionID },
) => {
  const url = `${assessmentService}/assessment/propertyapplicationexemption/${applicationExemptionID}/approve`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const undoExemption = async (
  { assessmentService },
  authenticationToken,
  { payload, applicationExemptionID },
) => {
  const url = `${assessmentService}/assessment/propertyapplicationexemption/${applicationExemptionID}/undo`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const uploadApplicationFile = async (
  { assessmentService },
  authenticationToken,
  { applicationID, payload },
) => {
  const url = `${assessmentService}/assessment/propertyapplication/${applicationID}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const updateApplicationFile = async (
  { assessmentService },
  authenticationToken,
  { payload, applicationID },
) => {
  const url = `${assessmentService}/assessment/propertyapplication/${applicationID}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadApplicationFile = async (
  { assessmentService },
  authenticationToken,
  { applicationID, s3ID },
) => {
  const url = `${assessmentService}/assessment/propertyapplication/${applicationID}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const retrieveApplicationFile = async (
  { assessmentService },
  authenticationToken,
  { applicationID, s3ID },
) => {
  const url = `${assessmentService}/assessment/propertyapplication/${applicationID}/file/${s3ID}`;
  const { body } = await get(authenticationToken, url, {
    outputType: 'bytearray',
  });
  return body;
};

export const deleteApplicationFile = async (
  { assessmentService },
  authenticationToken,
  { applicationID, s3ID, payload },
) => {
  const url = `${assessmentService}/assessment/propertyapplication/${applicationID}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const searchApplicationEvents = async (
  { eventService },
  authenticationToken,
  {
    page,
    pageSize,
    sortField,
    sortDirection,
    applicationID,
    filterModel,
    payload,
  },
) => {
  let url = `${eventService}/events/search?page=${page}&pageSize=${pageSize}`;

  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }

  if (filterModel && Object.keys(filterModel).length >= 0) {
    Object.keys(filterModel).forEach((filter) => {
      url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
    });
  }

  const { body } = await post(authenticationToken, url, {
    ...payload,
    objectID: `${applicationID}`,
    dataObject: 'application',
  });
  return body;
};

export const fetchApplicationEventTags = async (
  { eventService },
  authenticationToken,
) => {
  const url = `${eventService}/events/tags`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchApplicationEventTypes = async (
  { eventService },
  authenticationToken,
) => {
  const url = `${eventService}/events/eventtypes`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchApplicationEventForms = async (
  { eventService },
  authenticationToken,
  { dataObject },
) => {
  const url = `${eventService}/events/peventforms?dataObject=${dataObject}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

// Valuations BPP
export const fetchAllValuationsBpp = async (
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/propertyvaluationsbpp`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchBppSubDetails = async (
  { appraisalService },
  authenticationToken,
  { pDetailID },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/${pDetailID}/subdetails`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createBppSubDetail = async (
  { appraisalService },
  authenticationToken,
  { pDetailID, payload },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/${pDetailID}/subdetails`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateBppSubDetail = async (
  { appraisalService },
  authenticationToken,
  { pSubDetailID, payload },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/subdetail/${pSubDetailID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteBppSubDetail = async (
  { appraisalService },
  authenticationToken,
  { pSubDetailID },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/subdetail/${pSubDetailID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const deleteAllBppSubDetails = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/subdetails/massdelete`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const massUpdateBppSubDetail = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/subdetails/massupdate`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export async function createPropertyValuationBpp(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, data },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/propertyvaluationsbpp`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export const fetchPersonalDetailSummary = async (
  { appraisalService },
  authenticationToken,
  { pBusinessPropId },
) => {
  const url = `${appraisalService}/appraisal/bppapproach/${pBusinessPropId}/personaldetailsummary`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchValuationBppTypes = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/valuationbpptypes`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateValuationBpp = async (
  { appraisalService },
  authenticationToken,
  { pBusinessPropId, data },
) => {
  const url = `${appraisalService}/appraisal/valuationbpp/${pBusinessPropId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const exportAllPersonalDetails = async (
  { appraisalService },
  authenticationToken,
  { pBusinessPropId },
) => {
  let url = `${appraisalService}/appraisal/bppapproach/${pBusinessPropId}/personaldetails?export=1`;

  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchAllPersonalDetails = async (
  { appraisalService },
  authenticationToken,
  {
    pBusinessPropId,
    pageSize = 50,
    page = 1,
    sortField,
    sortDirection,
    searchField,
    searchText,
    importErrorsOnly = false,
  },
) => {
  let url = `${appraisalService}/appraisal/bppapproach/${pBusinessPropId}/personaldetails`;
  if (page !== 'none' && pageSize !== 'none') {
    url += `?page=${page}&pageSize=${pageSize}`;
  }

  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }

  if (searchField && searchText) {
    url += `&searchField=${searchField}&searchText=${searchText}`;
  }

  if (importErrorsOnly) {
    url += `&importErrorsOnly=${Number(importErrorsOnly)}`;
  }

  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPersonalDetail = async (
  { appraisalService },
  authenticationToken,
  { detailId },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/${detailId}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertPersonalDetail = async (
  { appraisalService },
  authenticationToken,
  { pBusinessPropId, data },
) => {
  const url = `${appraisalService}/appraisal/bppapproach/${pBusinessPropId}/personaldetails`;
  const { body } = await post(authenticationToken, url, data);
  return body;
};

export const updatePersonalDetail = async (
  { appraisalService },
  authenticationToken,
  { detailId, data },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/${detailId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const deletePersonalDetail = async (
  { appraisalService },
  authenticationToken,
  { detailId },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/${detailId}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const deleteAllPersonalDetails = async (
  { appraisalService },
  authenticationToken,
  { pBusinessPropId },
) => {
  const url = `${appraisalService}/appraisal/bppapproach/${pBusinessPropId}/personaldetails`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchPersonalDetailTaxingUnits = async (
  { appraisalService },
  authenticationToken,
  { detailId },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/${detailId}/taxingunits`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertPersonalDetailTaxingUnit = async (
  { appraisalService },
  authenticationToken,
  { detailId, data },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/${detailId}/taxingunits`;
  const { body } = await post(authenticationToken, url, data);
  return body;
};

export const updatePersonalDetailTaxingUnit = async (
  { appraisalService },
  authenticationToken,
  { detailTaxingUnitId, data },
) => {
  const url = `${appraisalService}/appraisal/personaldetailtaxingunit/${detailTaxingUnitId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const deletePersonalDetailTaxingUnit = async (
  { appraisalService },
  authenticationToken,
  { detailTaxingUnitId },
) => {
  const url = `${appraisalService}/appraisal/personaldetailtaxingunit/${detailTaxingUnitId}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchPersonalDepreciationCategoryMethods = async (
  { appraisalService },
  authenticationToken,
  { pYear },
) => {
  const url = `${appraisalService}/appraisal/personaldepreciationcategorymethods/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

// ***

// Renditions BPP
export const fetchAllRenditionsBpp = async (
  { appraisalService },
  authenticationToken,
  { propertyId },
) => {
  const url = `${appraisalService}/appraisal/property/${propertyId}/personal/renditions`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertPersonalRendition = async (
  { appraisalService },
  authenticationToken,
  { propertyId, data },
) => {
  const url = `${appraisalService}/appraisal/property/${propertyId}/personal/renditions`;
  const { body } = await post(authenticationToken, url, data);
  return body;
};

export const updatePersonalRendition = async (
  { appraisalService },
  authenticationToken,
  { renditionId, data },
) => {
  const url = `${appraisalService}/appraisal/personalrendition/${renditionId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const personalRenditionActivate = async (
  { appraisalService },
  authenticationToken,
  { renditionId, data },
) => {
  const url = `${appraisalService}/appraisal/personalrendition/${renditionId}/activate`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const personalRenditionDeactivate = async (
  { appraisalService },
  authenticationToken,
  { renditionId, data },
) => {
  const url = `${appraisalService}/appraisal/personalrendition/${renditionId}/deactivate`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const deletePersonalRendition = async (
  { appraisalService },
  authenticationToken,
  { renditionId },
) => {
  const url = `${appraisalService}/appraisal/personalrendition/${renditionId}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const insertPersonalRenditionFiles = async (
  { appraisalService },
  authenticationToken,
  { renditionId, data },
) => {
  const url = `${appraisalService}/appraisal/personalrendition/${renditionId}/files`;
  const { body } = await upload(authenticationToken, url, data);
  return body;
};

export const updatePersonalRenditionFile = async (
  { appraisalService },
  authenticationToken,
  { renditionId, data },
) => {
  const url = `${appraisalService}/appraisal/personalrendition/${renditionId}/files`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const getPersonalRenditionFile = async (
  { appraisalService },
  authenticationToken,
  { renditionId, s3Id },
) => {
  const url = `${appraisalService}/appraisal/personalrendition/${renditionId}/file/${s3Id}`;
  const { body } = await get(authenticationToken, url, {
    outputType: 'bytearray',
  });
  return body;
};

export const deletePersonalRenditionFile = async (
  { appraisalService },
  authenticationToken,
  { renditionId, s3Id, data },
) => {
  const url = `${appraisalService}/appraisal/personalrendition/${renditionId}/file/${s3Id}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const verifyPersonalRendition = async (
  { appraisalService },
  authenticationToken,
  { renditionId, data },
) => {
  const url = `${appraisalService}/appraisal/personalrendition/${renditionId}/verify`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const unverifyPersonalRendition = async (
  { appraisalService },
  authenticationToken,
  { renditionId, data },
) => {
  const url = `${appraisalService}/appraisal/personalrendition/${renditionId}/unverify`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const fetchPrimaryOwnerDetails = async (
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/primaryowner`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPreviousYearDetails = async (
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/previousyearbpp`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertPersonalDetailRendition = async (
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, data },
) => {
  const url = `${appraisalService}/appraisal/bppapproach/${propertyId}/${pYear}/renditionpersonaldetails`;
  const { body } = await post(authenticationToken, url, data);
  return body;
};

export const fetchCanProcessRendition = async (
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/canprocessrendition`;
  const { body } = await get(authenticationToken, url);
  return body;
};

// ***
export async function fetchExemptionNotes(
  { assessmentService },
  authenticationToken,
  { propertyId },
) {
  const url = `${assessmentService}/assessment/property/${propertyId}/exemptionnotes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteExemptionNote(
  { assessmentService },
  authenticationToken,
  { noteID },
) {
  const url = `${assessmentService}/assessment/exemptionnote/${noteID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateExemptionNote(
  { assessmentService },
  authenticationToken,
  { noteID, payload },
) {
  const url = `${assessmentService}/assessment/exemptionnote/${noteID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function addExemptionNote(
  { assessmentService },
  authenticationToken,
  { pID, payload },
) {
  const url = `${assessmentService}/assessment/property/${pID}/exemptionnotes`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchAllDistinctExemptions(
  { assessmentService },
  authenticationToken,
) {
  const url = `${assessmentService}/assessment/exemptions/distinct`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchCurrentApplicationOwners(
  { assessmentService },
  authenticationToken,
  { propertyId },
) {
  const url = `${assessmentService}/assessment/property/${propertyId}/applicationcurrentowners`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchHSDetails(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/costhsdetails`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyOwnerNames(
  { appraisalService },
  authenticationToken,
  { propertyId, selectedYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${selectedYear}/${pVersion}/${pRollCorr}/ownernamelisting`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTaxable(
  { assessmentService },
  authenticationToken,
  { pAccountId },
) {
  const url = `${assessmentService}/assessment/propertyaccount/${pAccountId}/taxable`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTaxableDetails(
  { assessmentService },
  authenticationToken,
  { pAccountId, taxingUnitID },
) {
  const queryParams = taxingUnitID ? `?taxingUnitID=${taxingUnitID}` : '';
  const url = `${assessmentService}/assessment/propertyaccount/${pAccountId}/taxabledetail${queryParams}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTaxingUnitSplitBoundaryLines(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/taxingunitsplitboundarylines`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateTaxingUnitSplitBoundaryLines(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, payload },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/taxingunitsplitboundarylines`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchTaxingUnitSegments(
  { assessmentService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${assessmentService}/assessment/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/taxingunitsegments`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTaxingUnitSegment(
  { assessmentService },
  authenticationToken,
  { segmentType, segmentID },
) {
  const url = `${assessmentService}/assessment/property/taxingunitsegment/${segmentType}/${segmentID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateTaxingUnitSegment(
  { assessmentService },
  authenticationToken,
  { segmentType, segmentID, payload },
) {
  const url = `${assessmentService}/assessment/property/taxingunitsegment/${segmentType}/${segmentID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchPropertySmartGroups(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/smartgroups`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSmartGroupProperties(
  { appraisalService },
  authenticationToken,
  { groupId },
) {
  const url = `${appraisalService}/appraisal/smartgroup/${groupId}/properties`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertSmartGroupProperty(
  { appraisalService },
  authenticationToken,
  { groupId, pId },
) {
  const url = `${appraisalService}/appraisal/smartgroup/${groupId}/properties`;
  const { body } = await post(authenticationToken, url, { pID: pId });
  return body;
}

export async function deleteSmartGroupProperty(
  { appraisalService },
  authenticationToken,
  { groupPropId },
) {
  const url = `${appraisalService}/appraisal/smartgroupproperty/${groupPropId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function excludeOwnerFromHSSmartGroupCalc(
  { appraisalService },
  authenticationToken,
  { pAccountID, payload },
) {
  const url = `${appraisalService}/appraisal/smartgrouppropertyowner/${pAccountID}/setexcludefromhsgroup`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchSmartGroup(
  { appraisalService },
  authenticationToken,
  { groupId },
) {
  const url = `${appraisalService}/appraisal/smartgroup/${groupId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateSmartGroup(
  { appraisalService },
  authenticationToken,
  { groupId, payload },
) {
  const url = `${appraisalService}/appraisal/smartgroup/${groupId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const insertSmartGroupFile = async (
  { appraisalService },
  authenticationToken,
  { groupId, payload },
) => {
  const url = `${appraisalService}/appraisal/smartgroup/${groupId}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const deleteSmartGroupFile = async (
  { appraisalService },
  authenticationToken,
  { groupId, s3ID, payload },
) => {
  const url = `${appraisalService}/appraisal/smartgroup/${groupId}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadSmartGroupFile = async (
  { appraisalService },
  authenticationToken,
  { groupId, s3ID },
) => {
  const url = `${appraisalService}/appraisal/smartgroup/${groupId}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const updateSmartGroupFile = async (
  { appraisalService },
  authenticationToken,
  { groupId, payload },
) => {
  const url = `${appraisalService}/appraisal/smartgroup/${groupId}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchSmartGroupTypes = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codes?type=Property&name=Smart%20Groups`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertSmartGroup = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/appraisal/smartgroups`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchSmartGroupsBySearch = async (
  { appraisalService },
  authenticationToken,
  { payload, page, pageSize },
) => {
  let url = `${appraisalService}/appraisal/smartgroup/search`;
  if (page && pageSize) {
    url += `?page=${page}&pageSize=${pageSize}`;
  }
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchPropertyInspections = async (
  { appraisalService },
  authenticationToken,
  { pId },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/inspections`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertPropertyInspection = async (
  { appraisalService },
  authenticationToken,
  { pId, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/inspections`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchReasonCodes = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codes?type=Property&name=Inspections`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPropertyInspection = async (
  { appraisalService },
  authenticationToken,
  { inspectionId },
) => {
  const url = `${appraisalService}/appraisal/propertyinspection/${inspectionId}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertPropertyInspectionTags = async (
  { appraisalService },
  authenticationToken,
  { inspectionId, payload },
) => {
  const url = `${appraisalService}/appraisal/propertyinspection/${inspectionId}/tags`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const updatePropertyInspection = async (
  { appraisalService },
  authenticationToken,
  { inspectionId, payload },
) => {
  const url = `${appraisalService}/appraisal/propertyinspection/${inspectionId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const insertPropertyInspectionFile = async (
  { appraisalService },
  authenticationToken,
  { inspectionId, payload },
) => {
  const url = `${appraisalService}/appraisal/propertyinspection/${inspectionId}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const deletePropertyInspectionFile = async (
  { appraisalService },
  authenticationToken,
  { inspectionId, s3ID, payload },
) => {
  const url = `${appraisalService}/appraisal/propertyinspection/${inspectionId}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadPropertyInspectionFile = async (
  { appraisalService },
  authenticationToken,
  { inspectionId, s3ID },
) => {
  const url = `${appraisalService}/appraisal/propertyinspection/${inspectionId}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const updatePropertyInspectionFile = async (
  { appraisalService },
  authenticationToken,
  { inspectionId, payload },
) => {
  const url = `${appraisalService}/appraisal/propertyinspection/${inspectionId}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchPropertyAppraisers = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/appraisers`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updatePropertyAppraisers = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion = 0, pRollCorr = 0, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/appraisers`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deletePropertyInspection = async (
  { appraisalService },
  authenticationToken,
  { inspectionId },
) => {
  const url = `${appraisalService}/appraisal/propertyinspection/${inspectionId}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchPropertyPrimaryAppraiser = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/primaryappraiser`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPropertyEditableStatus = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/iseditable`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPropertyStatus = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/propertystatus`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const deleteSmartGroup = async (
  { appraisalService },
  authenticationToken,
  { smartGroupId },
) => {
  const url = `${appraisalService}/appraisal/smartgroup/${smartGroupId}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchPropertyPrimaryImageUrl = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/primaryimage`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchObjectEvents = async (
  { eventService },
  authenticationToken,
  { objectId, type },
) => {
  let url = `${eventService}/events/object/${objectId}/events`;
  if (type) {
    url += `?eventType=${type}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPhotosAndDocuments = async (
  { eventService },
  authenticationToken,
  { objectId, type },
) => {
  let url = `${eventService}/events/object/${objectId}/photosdocs?fileType=${type}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPropertyAgentSummaryListing = async (
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion, pRollCorr },
) => {
  const url =
    `${appraisalService}/appraisal/property/${propertyId}/${pYear}/` +
    `${pVersion}/${pRollCorr}/agentsummary`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPropertyAgentSummary = async (
  { appraisalService },
  authenticationToken,
  { pAccountId },
) => {
  const url = `${appraisalService}/appraisal/propertyaccount/${pAccountId}/agentlisting`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchBuildingPermits = async (
  { appraisalService },
  authenticationToken,
  { pId },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/buildingpermits`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchNextGeoID = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/nextgeoid`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPreviousGeoID = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/previousgeoid`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchNextBlockLot = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/nextblocklot`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPreviousBlockLot = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/previousblocklot`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchAllHsValueLimitations = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/hsvaluelimitations`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchBuildingPermitCodefiles = async (
  { appraisalService },
  authenticationToken,
  { name },
) => {
  const url = `${appraisalService}/appraisal/codes?type=Building Permits&name=${name}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updatePropertyHsValueLimitation = async (
  { appraisalService },
  authenticationToken,
  { pAccountId, payload },
) => {
  const url = `${appraisalService}/appraisal/propertyaccount/${pAccountId}/hsvaluelimitation`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const insertBuildingPermit = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/appraisal/buildingpermits`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateBuildingPermitTags = async (
  { appraisalService },
  authenticationToken,
  { permitId, payload },
) => {
  const url = `${appraisalService}/appraisal/buildingpermit/${permitId}/tags`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchBuildingPermit = async (
  { appraisalService },
  authenticationToken,
  { permitId },
) => {
  const url = `${appraisalService}/appraisal/buildingpermit/${permitId}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateBuildingPermit = async (
  { appraisalService },
  authenticationToken,
  { permitId, payload },
) => {
  const url = `${appraisalService}/appraisal/buildingpermit/${permitId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchBuildingPermitProperties = async (
  { appraisalService },
  authenticationToken,
  { permitId },
) => {
  const url = `${appraisalService}/appraisal/buildingpermit/${permitId}/properties`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertBuildingPermitProperty = async (
  { appraisalService },
  authenticationToken,
  { permitId, payload },
) => {
  const url = `${appraisalService}/appraisal/buildingpermit/${permitId}/properties`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteBuildingPermitProperty = async (
  { appraisalService },
  authenticationToken,
  { permitPropId, payload },
) => {
  const url = `${appraisalService}/appraisal/buildingpermitproperty/${permitPropId}`;
  const { body } = await del(authenticationToken, url, payload);
  return body;
};

export const insertBuildingPermitFile = async (
  { appraisalService },
  authenticationToken,
  { permitId, payload },
) => {
  const url = `${appraisalService}/appraisal/buildingpermit/${permitId}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const deleteBuildingPermitFile = async (
  { appraisalService },
  authenticationToken,
  { permitId, s3ID, payload },
) => {
  const url = `${appraisalService}/appraisal/buildingpermit/${permitId}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadBuildingPermitFile = async (
  { appraisalService },
  authenticationToken,
  { permitId, s3ID },
) => {
  const url = `${appraisalService}/appraisal/buildingpermit/${permitId}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const updateBuildingPermitFile = async (
  { appraisalService },
  authenticationToken,
  { permitId, payload },
) => {
  const url = `${appraisalService}/appraisal/buildingpermit/${permitId}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchLastAppraisal = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/lastappraisal`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateLastAppraisal = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion = 0, pRollCorr = 0, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/lastappraisal`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchCodefilePropertyTags = async (
  { appraisalService },
  authenticationToken,
  { pYear },
) => {
  const url = `${appraisalService}/appraisal/codes?type=Property&year=${pYear}&name=Tags`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchImprovementDetailTypes = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codes?type=Improvement%20Detail&name=Type`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPropertyLinks = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/links`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPropertyTags = async (
  { appraisalService },
  authenticationToken,
  { pYear, pId },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/tags`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertPropertyTag = async (
  { appraisalService },
  authenticationToken,
  { pYear, pId, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/tags`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deletePropertyTag = async (
  { appraisalService },
  authenticationToken,
  { tagId },
) => {
  const url = `${appraisalService}/appraisal/property/tag/${tagId}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const deletePropertyLink = async (
  { appraisalService },
  authenticationToken,
  { linkID },
) => {
  const url = `${appraisalService}/appraisal/propertylink/${linkID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const insertPropertyLink = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/links`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchRecalculationJob = async (
  { recalculationService },
  authenticationToken,
  { jobId },
) => {
  const url = `${recalculationService}/recalc/job/${jobId}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function duplicateImprovement(
  { appraisalService },
  authenticationToken,
  { improvementId },
) {
  const url = `${appraisalService}/appraisal/improvement/${improvementId}/duplicate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function duplicateImprovementDetail(
  { appraisalService },
  authenticationToken,
  { improvementDetailId },
) {
  // if (sketchData && sketchData.sketchID) {
  //   updateImprovementSketch({appraisalService}, authenticationToken, { sketchData });
  // }
  const url = `${appraisalService}/appraisal/improvementdetail/${improvementDetailId}/duplicate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function duplicateLand(
  { appraisalService },
  authenticationToken,
  { landId },
) {
  const url = `${appraisalService}/appraisal/land/${landId}/duplicate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export const fetchMostCurrentProperty = async (
  { appraisalService },
  authenticationToken,
  { pid },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/mostcurrent`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchMostCurrentPropertyByYear = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/current`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function fetchRollHistory(
  { appraisalService },
  authenticationToken,
  { propertyId },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/rollhistory`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraisalNoticeHistory(
  { appraisalService },
  authenticationToken,
  { propertyId },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/appraisalnoticehistory`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export const fetchCurrentImprovements = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/byyearimprovements?pYear=${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const copySpecificImprovement = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion, pRollCorr, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/copyspecificimprovement`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const copySpecificImprovementBuilder = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/appraisal/builderplan/copyimprovementspecific`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchCurrentLands = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/byyearland?pYear=${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const copySpecificLand = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion, pRollCorr, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/copyspecificland`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const copySpecificLandBuilder = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/appraisal/builderplan/copylandspecific`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchWorkItemTypes = async (
  { queueService },
  authenticationToken,
) => {
  const url = `${queueService}/queue/workitemdefinitiontypesubtypes`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertWorkItemAndProperties = async (
  { queueService },
  authenticationToken,
  { payload },
) => {
  const url = `${queueService}/queue/workitem/property/masscreate`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const insertWorkItem = async (
  { queueService },
  authenticationToken,
  { payload },
) => {
  const url = `${queueService}/queue/workitems`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const insertWorkItemProperty = async (
  { queueService },
  authenticationToken,
  { workItemID, payload },
) => {
  const url = `${queueService}/queue/workitem/${workItemID}/properties`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const insertWorkItemIntegrityCheck = async (
  { queueService },
  authenticationToken,
  { payload },
) => {
  const url = `${queueService}/queue/workitem/property/masscreate/integrity`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const insertWorkItemFile = async (
  { queueService },
  authenticationToken,
  { workItemID, payload },
) => {
  const url = `${queueService}/queue/workitem/${workItemID}/fileattachments`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const deleteWorkItemFile = async (
  { queueService },
  authenticationToken,
  { workItemFileAttachmentID },
) => {
  const url = `${queueService}/queue/workitem/fileattachment/${workItemFileAttachmentID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const downloadWorkItemFile = async (
  { queueService },
  authenticationToken,
  { workItemFileAttachmentID },
) => {
  const url = `${queueService}/queue/workitem/fileattachment/${workItemFileAttachmentID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchWorkItemFiles = async (
  { queueService },
  authenticationToken,
  { workItemID },
) => {
  const url = `${queueService}/queue/workitem/${workItemID}/fileattachments`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertRenditionExtensionFile = async (
  { appraisalService },
  authenticationToken,
  { pID, pYear, pRollCorr, pVersion, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pID}/${pYear}/${pVersion}/${pRollCorr}/bpprenditionextensionrequests/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const editRenditionExtensionFile = async (
  { appraisalService },
  authenticationToken,
  { pID, pYear, pRollCorr, pVersion, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pID}/${pYear}/${pVersion}/${pRollCorr}/bpprenditionextensionrequests/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteRenditionExtensionFile = async (
  { appraisalService },
  authenticationToken,
  { pID, pYear, pRollCorr, pVersion, s3ID },
) => {
  const url = `${appraisalService}/appraisal/property/bpprenditionextensionrequests/${pID}/${pYear}/${pVersion}/${pRollCorr}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const downloadRenditionExtensionFile = async (
  { appraisalService },
  authenticationToken,
  { pID, pYear, pRollCorr, pVersion, s3ID },
) => {
  const url = `${appraisalService}/appraisal/property/bpprenditionextensionrequests/${pID}/${pYear}/${pVersion}/${pRollCorr}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const fetchRenditionExtensionFiles = async (
  { appraisalService },
  authenticationToken,
  { pID, pYear, pRollCorr, pVersion },
) => {
  const url = `${appraisalService}/appraisal/property/${pID}/${pYear}/${pVersion}/${pRollCorr}/bpprenditionextensionrequests`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertLatePenaltyFile = async (
  { appraisalService },
  authenticationToken,
  { pID, pYear, pRollCorr, pVersion, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pID}/${pYear}/${pVersion}/${pRollCorr}/bpprenditionpenality/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const deleteLatePenaltyFile = async (
  { appraisalService },
  authenticationToken,
  { pID, pYear, pRollCorr, pVersion, s3ID },
) => {
  const url = `${appraisalService}/appraisal/property/bpprenditionpenality/${pID}/${pYear}/${pVersion}/${pRollCorr}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const editLatePenaltyFile = async (
  { appraisalService },
  authenticationToken,
  { pID, pYear, pRollCorr, pVersion, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pID}/${pYear}/${pVersion}/${pRollCorr}/bpprenditionpenality/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadLatePenaltyFile = async (
  { appraisalService },
  authenticationToken,
  { pID, pYear, pRollCorr, pVersion, s3ID },
) => {
  const url = `${appraisalService}/appraisal/property/bpprenditionpenality/${pID}/${pYear}/${pVersion}/${pRollCorr}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const fetchLatePenaltyFiles = async (
  { appraisalService },
  authenticationToken,
  { pID, pYear, pRollCorr, pVersion },
) => {
  const url = `${appraisalService}/appraisal/property/${pID}/${pYear}/${pVersion}/${pRollCorr}/bpprenditionpenality`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPropertyValueReady = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/valueReady`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updatePropertyValueReady = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/valueReady`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const updatePropertySpecialUseReset = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/sureset`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchOpenRollCorrectionsByYear = async (
  { appraisalService },
  authenticationToken,
  { year },
) => {
  const url = `${appraisalService}/appraisal/rollcorrection/${year}/open?includePending=1`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertRollCorrection = async (
  { appraisalService },
  authenticationToken,
  { year },
) => {
  const url = `${appraisalService}/appraisal/rollcorrections`;
  const { body } = await post(authenticationToken, url, { pYear: year });
  return body;
};

export const createPropertyRollCorrection = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, data },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/rollcorrection`;
  const { body } = await post(authenticationToken, url, data);
  return body;
};

export const removePropertyFromRollCorrection = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/rollcorrection/delete`;
  const { body } = await post(authenticationToken, url);
  return body;
};

export const fetchPropertyRollCorrectionInfo = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr },
) => {
  const url =
    `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/` +
    `${pRollCorr}/rollcorrectioninfo`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updatePropertyRollCorrectionInfo = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, payload },
) => {
  const url =
    `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/` +
    `${pRollCorr}/rollcorrectioninfo`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const getPropertyFiles = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/files`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const uploadPropertyFile = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const uploadPropertyPrimaryImage = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/primaryimageupload`;
  const { body } = await uploadPut(authenticationToken, url, payload);
  return body;
};

export const updateCurrentPropertyPrimaryImage = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/primaryimageupdatecurrent`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deletePropertyFile = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, s3Id, lastUpdate },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/file/${s3Id}`;
  const { body } = await put(authenticationToken, url, { lastUpdate });
  return body;
};

export const updatePropertyFile = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadPropertyFile = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, s3Id },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/file/${s3Id}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3Id;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const fetchPropertyPlats = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/plats`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const downloadPropertyPlat = async (
  { appraisalService },
  authenticationToken,
  { platID, s3ID },
) => {
  const url = `${appraisalService}/appraisal/abstractsubdivisionplat/${platID}/file/${s3ID}`;
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function deletePropertyMassCreateProperty(
  { appraisalService },
  authenticationToken,
  { massCreatePropertyID },
) {
  const url = `${appraisalService}/appraisal/property/masscreate/property/${massCreatePropertyID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export const fetchJanOneOwner = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/jan1owners`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function fetchCalculationRules(
  { assessmentService },
  authenticationToken,
) {
  const url = `${assessmentService}/assessment/exemption/calculationrule`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export const fetchAllocationFactors = async (
  { assessmentService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr },
) => {
  const url = `${assessmentService}/assessment/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/allocationfactors`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function deleteAllocationFactor(
  { assessmentService },
  authenticationToken,
  { pTaxingUnitAllocationFactorID },
) {
  const url = `${assessmentService}/assessment/property/allocationfactors/${pTaxingUnitAllocationFactorID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateAllocationFactor(
  { assessmentService },
  authenticationToken,
  { pTaxingUnitAllocationFactorID, payload },
) {
  const url = `${assessmentService}/assessment/property/allocationfactors/${pTaxingUnitAllocationFactorID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const insertAllocationFactor = async (
  { assessmentService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, payload },
) => {
  const url = `${assessmentService}/assessment/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/allocationfactors`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchTaxingUnitLookup = async (
  { gamaService },
  authenticationToken,
  { address },
) => {
  const url = `${gamaService}/gama/property/taxingunitlookup?address=${address}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const processTaxingUnitAffidavit = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/appraisal/bppimport/affidavitexemptioncheck`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchPropertyForSIT = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const enableSIT = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/sit_enable`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const disableSIT = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/sit_remove`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchSITDetails = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0, filedYr = 'All' },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/sitdetails?filedYr=${
    filedYr ? filedYr : 'All'
  }`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchSIT = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0, filedYr = 'All' },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/sit?filedYr=${
    filedYr ? filedYr : 'All'
  }`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateSIT = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/sit`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchSITDetail = async (
  { appraisalService },
  authenticationToken,
  { sitDetailID },
) => {
  const url = `${appraisalService}/appraisal/property/sitdetail/${sitDetailID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPropertyEconUnit = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/economicunitvaluation`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateSITDetail = async (
  { appraisalService },
  authenticationToken,
  { sitDetailID, payload },
) => {
  const url = `${appraisalService}/appraisal/property/sitdetail/${sitDetailID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const insertSITDetail = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/sitdetails`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteSITDetail = async (
  { appraisalService },
  authenticationToken,
  { sitDetailID, payload },
) => {
  const url = `${appraisalService}/appraisal/property/sitdetail/${sitDetailID}`;
  const { body } = await del(authenticationToken, url, payload);
  return body;
};

export const insertSitDetailFile = async (
  { appraisalService },
  authenticationToken,
  { sitDetailID, payload },
) => {
  const url = `${appraisalService}/appraisal/property/sitdetail/${sitDetailID}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const deleteSitDetailFile = async (
  { appraisalService },
  authenticationToken,
  { sitDetailID, s3ID, payload },
) => {
  const url = `${appraisalService}/appraisal/property/sitdetail/${sitDetailID}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadSitDetailFile = async (
  { appraisalService },
  authenticationToken,
  { sitDetailID, s3ID },
) => {
  const url = `${appraisalService}/appraisal/property/sitdetail/${sitDetailID}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const updateSitDetailFile = async (
  { appraisalService },
  authenticationToken,
  { sitDetailID, payload },
) => {
  const url = `${appraisalService}/appraisal/property/sitdetail/${sitDetailID}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const insertSitFile = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/sit/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const deleteSitFile = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0, s3ID, payload },
) => {
  const url = `${appraisalService}/appraisal/property/sit/${pid}/${pYear}/${pVersion}/${pRollCorr}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadSitFile = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0, s3ID },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const updateSitFile = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/sit/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export async function createBppImport(
  { appraisalService },
  authenticationToken,
  {
    payload,
    propertyID,
    propertyYear,
    propertyVersion = 0,
    propertyRollCorr = 0,
  },
) {
  const url = `${appraisalService}/appraisal/property/${propertyID}/${propertyYear}/${propertyVersion}/${propertyRollCorr}/bppimport`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export const fetchBppImport = async (
  { appraisalService },
  authenticationToken,
  { importID },
) => {
  const url = `${appraisalService}/appraisal/bppimport/${importID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchBppImportErrors = async (
  { appraisalService },
  authenticationToken,
  { importID },
) => {
  const url = `${appraisalService}/appraisal/bppimport/${importID}/errors`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const clearImportErrors = async (
  { appraisalService },
  authenticationToken,
  { pDetailId, data },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/${pDetailId}/clearimporterror`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const fetchMarketApproachValuation = async (
  { appraisalService },
  authenticationToken,
  { pMarketId },
) => {
  const url = `${appraisalService}/appraisal/marketapproach/${pMarketId}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateMarketApproachAutoSelect = async (
  { appraisalService },
  authenticationToken,
  { pMarketId },
) => {
  const url = `${appraisalService}/appraisal/marketapproach/${pMarketId}/autoselect`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const updateMarketApproachSetLandGrid = async (
  { appraisalService },
  authenticationToken,
  { pMarketId },
) => {
  const url = `${appraisalService}/appraisal/marketapproach/${pMarketId}/setlandgrid`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const fetchMarketApproachCompImages = async (
  { appraisalService },
  authenticationToken,
  { pMarketId },
) => {
  const url = `${appraisalService}/appraisal/marketapproach/${pMarketId}/compimages`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const refreshMarketApproach = async (
  { appraisalService },
  authenticationToken,
  { pMarketId },
) => {
  const url = `${appraisalService}/appraisal/marketapproach/${pMarketId}/refresh`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const deleteMarketApproachComps = async (
  { appraisalService },
  authenticationToken,
  { pMarketId, payload },
) => {
  const url = `${appraisalService}/appraisal/marketapproach/${pMarketId}/deletecomps`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchEquityApproachValuation = async (
  { appraisalService },
  authenticationToken,
  { pEquityId },
) => {
  const url = `${appraisalService}/appraisal/equityapproach/${pEquityId}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateEquityApproachAutoSelect = async (
  { appraisalService },
  authenticationToken,
  { pEquityId },
) => {
  const url = `${appraisalService}/appraisal/equityapproach/${pEquityId}/autoselect`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const updateEquityApproachSetLandGrid = async (
  { appraisalService },
  authenticationToken,
  { pEquityId },
) => {
  const url = `${appraisalService}/appraisal/equityapproach/${pEquityId}/setlandgrid`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const fetchEquityApproachCompImages = async (
  { appraisalService },
  authenticationToken,
  { pEquityId },
) => {
  const url = `${appraisalService}/appraisal/equityapproach/${pEquityId}/compimages`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const refreshEquityApproach = async (
  { appraisalService },
  authenticationToken,
  { pEquityId },
) => {
  const url = `${appraisalService}/appraisal/equityapproach/${pEquityId}/refresh`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const deleteEquityApproachComps = async (
  { appraisalService },
  authenticationToken,
  { pEquityId, payload },
) => {
  const url = `${appraisalService}/appraisal/equityapproach/${pEquityId}/deletecomps`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export async function fetchAppeals(
  { appealsService },
  authenticationToken,
  { pID },
) {
  const url = `${appealsService}/prodigyappeals/property/${pID}/appeals`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMarketApproachSubject(
  { appraisalService },
  authenticationToken,
  { pMarketId },
) {
  const url = `${appraisalService}/appraisal/marketapproach/${pMarketId}/subject`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEquityApproachSubject(
  { appraisalService },
  authenticationToken,
  { pEquityId },
) {
  const url = `${appraisalService}/appraisal/equityapproach/${pEquityId}/subject`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export const marketApproachManualSelection = async (
  { appraisalService },
  authenticationToken,
  { pMarketId, payload },
) => {
  const url = `${appraisalService}/appraisal/marketapproach/${pMarketId}/manualselection`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const equityApproachManualSelection = async (
  { appraisalService },
  authenticationToken,
  { pEquityId, payload },
) => {
  const url = `${appraisalService}/appraisal/equityapproach/${pEquityId}/manualselection`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export async function fetchMarketApproachTiers(
  { appraisalService },
  authenticationToken,
  { year, type },
) {
  let url = `${appraisalService}/appraisal/comparablemarket/tierselection/${year}`;
  if (type) {
    url = `${url}?gridType=${type}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEquityApproachTiers(
  { appraisalService },
  authenticationToken,
  { year, type },
) {
  let url = `${appraisalService}/appraisal/comparableequity/tierselection/${year}`;
  if (type) {
    url = `${url}?gridType=${type}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export const marketApproachAddCompList = async (
  { appraisalService },
  authenticationToken,
  { pMarketId, payload },
) => {
  const url = `${appraisalService}/appraisal/marketapproach/${pMarketId}/comps`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const equityApproachAddCompList = async (
  { appraisalService },
  authenticationToken,
  { pEquityId, payload },
) => {
  const url = `${appraisalService}/appraisal/equityapproach/${pEquityId}/comps`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export async function fetchPropertyEfile(
  { appraisalNoticeService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr },
) {
  const url =
    `${appraisalNoticeService}/prodigyappraisalnotices/property/${pid}/${pYear}/` +
    `${pVersion}/${pRollCorr}/efile`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePropertyEfile(
  { appraisalNoticeService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, payload },
) {
  const url =
    `${appraisalNoticeService}/prodigyappraisalnotices/property/${pid}/${pYear}/` +
    `${pVersion}/${pRollCorr}/efile`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function generatePropertyEfilePin(
  { appraisalNoticeService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, payload },
) {
  const url =
    `${appraisalNoticeService}/prodigyappraisalnotices/property/${pid}/${pYear}/` +
    `${pVersion}/${pRollCorr}/generatepin`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchPropertyEquitySubject(
  { appraisalService },
  authenticationToken,
  { pId, pYear },
) {
  const url = `${appraisalService}/appraisal/equitysearch/${pId}/${pYear}/subject`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function searchPropertyEquity(
  { appraisalService },
  authenticationToken,
  payload,
) {
  const url = `${appraisalService}/appraisal/equitysearch`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchMethods({ appraisalService }, authenticationToken) {
  const url = `${appraisalService}/appraisal/modelland/methods`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchModels(
  { appraisalService },
  authenticationToken,
  { method, year },
) {
  const url = `${appraisalService}/appraisal/modelland/${method}?uiCode=1&modelYr=${year}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyErrors(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/errors`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function checkRecalcProperty(
  { recalculationService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${recalculationService}/recalc/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/checkforerrors`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function updatePropertyInactiveNote(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, data },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/inactivenotes`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function updatePropertyReactiveNote(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, data },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/reactivatenotes`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export const fetchGroupOpenRollCorrections = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/rollcorrections?groupStatus=Open&includePending=1`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const copyPropertyOtherYears = async (
  { appraisalService },
  authenticationToken,
  { pID, pYear, pVersion, pRollCorr, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pID}/${pYear}/${pVersion}/${pRollCorr}/copy`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const movePropertyOtherCorrection = async (
  { appraisalService },
  authenticationToken,
  { pID, pYear, pVersion, pRollCorr, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pID}/${pYear}/${pVersion}/${pRollCorr}/move`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const quickPropertyLookup = async (
  { appraisalService },
  authenticationToken,
  { lookup, year, detail },
) => {
  const url = `${appraisalService}/appraisal/propertyquicklookup?lookup=${lookup}&year=${year}&detail=${detail}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPropertyNotifications = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/tagnotfication`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function fetchPropertySearchParams(
  { appraisalService },
  authenticationToken,
  { userName },
) {
  const queryParam = userName ? `?userName=${userName}` : '';
  const url = `${appraisalService}/appraisal/property/searchparameters${queryParam}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertySearchParam(
  { appraisalService },
  authenticationToken,
  { searchParamID },
) {
  const url = `${appraisalService}/appraisal/property/searchparameter/${searchParamID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertPropertySearchParam(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/property/searchparameters`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updatePropertySearchParam(
  { appraisalService },
  authenticationToken,
  { searchParamID, payload },
) {
  const url = `${appraisalService}/appraisal/property/searchparameter/${searchParamID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function duplicatePropertySearchParam(
  { appraisalService },
  authenticationToken,
  { searchParamID },
) {
  const url = `${appraisalService}/appraisal/property/searchparameter/${searchParamID}/duplicate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function deletePropertySearchParam(
  { appraisalService },
  authenticationToken,
  { searchParamID },
) {
  const url = `${appraisalService}/appraisal/property/searchparameter/${searchParamID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export const fetchPropertyAppraisalCompanies = async (
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/appraisalcompany`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const addPropertyAppraisalCompany = async (
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/appraisalcompany`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updatePropertyAppraisalCompany = async (
  { appraisalService },
  authenticationToken,
  { propertyAppraisalCompanyID, payload },
) => {
  const url = `${appraisalService}/appraisal/property/appraisalcompany/${propertyAppraisalCompanyID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deletePropertyAppraisalCompany = async (
  { appraisalService },
  authenticationToken,
  { propertyAppraisalCompanyID },
) => {
  const url = `${appraisalService}/appraisal/property/appraisalcompany/${propertyAppraisalCompanyID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchPropertyAppraisalCompanyLastImport = async (
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/appraisalcompanylastimport`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPropertyWorkItems = async (
  { queueService },
  authenticationToken,
  { propertyId },
) => {
  const url = `${queueService}/queue/property/${propertyId}/workitems`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function fetchPropertyTaxOfficeIdentifier(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/taxofficeidentifier`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePropertyTaxOfficeIdentifier(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, payload },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/taxofficeidentifier`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchBPPLateRenditionPenalty(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/laterenditionpenalty`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateBPPLateRenditionPenalty(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, payload },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/laterenditionpenalty`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchBPPLateRenditionPenaltyNew(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/bpprenditionpenality`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateBPPLateRenditionPenaltyNew(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, payload },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/bpprenditionpenality`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchBPPRenditionExtensionRequests(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/bpprenditionextensionrequests`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateBPPRenditionExtensionRequests(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, payload },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/bpprenditionextensionrequests`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function checkPropertySmartGroup(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/rollcorrection/smartgroupproperties`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyCases(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0 },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/cases`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyAllCases(
  { appraisalService },
  authenticationToken,
  { propertyId },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/casesallyears`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function searchPropertyRendition(
  { appraisalService },
  authenticationToken,
  { propertyID },
) {
  const url = `${appraisalService}/appraisal/bpprendition/property/${propertyID}/search`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function uploadRenditionFiles(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/bpprendition/uploadfiles`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function processRendition(
  { appraisalService },
  authenticationToken,
  { propertyID, pYear, pVersion, pRollCorr, payload },
) {
  const url = `${appraisalService}/appraisal/property/${propertyID}/${pYear}/${pVersion}/${pRollCorr}/bpprenditionprocess`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchPropertyTIRZ(
  { assessmentService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr },
) {
  const url = `${assessmentService}/assessment/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/tirz`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function removePropertyTIRZ(
  { assessmentService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr },
) {
  const url = `${assessmentService}/assessment/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/tirz/remove`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function addPropertyTIRZ(
  { assessmentService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, payload },
) {
  const url = `${assessmentService}/assessment/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/tirz`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchPropertyTIRZTaxingUnits(
  { assessmentService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr },
) {
  const url = `${assessmentService}/assessment/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/tirz/taxingunits`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function clearPropertyTIRZTaxingUnitsValues(
  { assessmentService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr },
) {
  const url = `${assessmentService}/assessment/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/tirz/taxingunits/clearvalues`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function addPropertyTIRZTaxingUnit(
  { assessmentService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, payload },
) {
  const url = `${assessmentService}/assessment/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/tirz/taxingunits`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updatePropertyTIRZTaxingUnit(
  { assessmentService },
  authenticationToken,
  { propertyTirzTaxingUnitID, payload },
) {
  const url = `${assessmentService}/assessment/property/tirz/taxingunit/${propertyTirzTaxingUnitID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function copyPropertyTIRZTaxingUnit(
  { assessmentService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, payload },
) {
  const url = `${assessmentService}/assessment/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/tirz/taxingunits/setvalues`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchPropertyValueLockStatus(
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr },
) {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/valuelock`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePropertyValueLockStatus(
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, payload },
) {
  const url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/valuelock`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const insertPersonalDetailFile = async (
  { appraisalService },
  authenticationToken,
  { pDetailID, payload },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/${pDetailID}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const updatePersonalDetailFile = async (
  { appraisalService },
  authenticationToken,
  { pDetailID, payload },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/${pDetailID}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadPersonalDetailFile = async (
  { appraisalService },
  authenticationToken,
  { s3ID, pDetailID },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/${pDetailID}/file/${s3ID}`;
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const deletePersonalDetailFile = async (
  { appraisalService },
  authenticationToken,
  { s3ID, pDetailID },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/${pDetailID}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const fetchPersonalDetailFiles = async (
  { appraisalService },
  authenticationToken,
  { pDetailID },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/${pDetailID}/files`;
  let { body } = await get(authenticationToken, url);
  return body;
};

export const insertPersonalDetailNote = async (
  { appraisalService },
  authenticationToken,
  { pDetailID, payload },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/${pDetailID}/notes`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updatePersonalDetailNote = async (
  { appraisalService },
  authenticationToken,
  { noteID, payload },
) => {
  const url = `${appraisalService}/appraisal/personaldetailnote/${noteID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchPersonalDetailNote = async (
  { appraisalService },
  authenticationToken,
  { noteID },
) => {
  const url = `${appraisalService}/appraisal/personaldetailnote/${noteID}`;
  let { body } = await get(authenticationToken, url);
  return body;
};

export const deletePersonalDetailNote = async (
  { appraisalService },
  authenticationToken,
  { noteID },
) => {
  const url = `${appraisalService}/appraisal/personaldetailnote/${noteID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchPersonalDetailNotes = async (
  { appraisalService },
  authenticationToken,
  { pDetailID },
) => {
  const url = `${appraisalService}/appraisal/personaldetail/${pDetailID}/notes`;
  let { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPropertySalesListing = async (
  { appraisalService },
  authenticationToken,
  { pID },
) => {
  const url = `${appraisalService}/appraisal/property/${pID}/saleslisting`;
  let { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPropertyHomesiteFlags = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/costsegments`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const setPropertyHomesiteFlag = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion = 0, pRollCorr = 0, payload },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/homesiteflag`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchStateCodeListing = async (
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/statecodelisting`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function fetchOpenRollCorrectionGroups(
  { appraisalService },
  authenticationToken,
) {
  let url = `${appraisalService}/assessment/propertyapplication/openrollgroups`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchCanCopyCurrentYear(
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion, pRollCorr },
) {
  let url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/cancopycurrentyear`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function copyPropertyCurrentYear(
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion, pRollCorr },
) {
  let url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/copycurrentyear`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function changePropertyType(
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion, pRollCorr, payload },
) {
  let url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/changetype`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchImageGalleryOptions(
  { appraisalService },
  authenticationToken,
  { pId },
) {
  let url = `${appraisalService}/appraisal/property/${pId}/imagegalleryoptions`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchImageGalleryData(
  { appraisalService },
  authenticationToken,
  { pId, pYear, category, fileType },
) {
  let url = `${appraisalService}/appraisal/property/${pId}/imagegallery?pYear=${pYear}&category=${category}&fileType=${fileType}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function setTaxOfficeRefId(
  { appraisalService },
  authenticationToken,
  { propertyId, pYear, pVersion = 0, pRollCorr = 0, payload },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/${pYear}/${pVersion}/${pRollCorr}/settaxofficerefid`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function canCreateFutureVersion(
  { appraisalService },
  authenticationToken,
  { pId },
) {
  let url = `${appraisalService}/appraisal/property/${pId}/cancreatefutureversion`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createFutureVersion(
  { appraisalService },
  authenticationToken,
  { pId, payload },
) {
  let url = `${appraisalService}/appraisal/property/${pId}/createfutureversion`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteFutureVersion(
  { appraisalService },
  authenticationToken,
  { pId },
) {
  let url = `${appraisalService}/appraisal/property/${pId}/deletefutureversion`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function hasFutureVersion(
  { appraisalService },
  authenticationToken,
  { pId },
) {
  let url = `${appraisalService}/appraisal/property/${pId}/hasfutureversion`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyMarketValueWithValueType(
  { appraisalService },
  authenticationToken,
  { pId, pYear, pVersion, pRollCorr },
) {
  let url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/propertymarketvaluewithtype`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchFlatValuationConfig(
  { appraisalService },
  authenticationToken,
) {
  let url = `${appraisalService}/appraisal/configuration/fetchbyname/flatPrimaryValuation`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTaxLimitationCalcStartYear(
  { appraisalService },
  authenticationToken,
  { pAccountID },
) {
  let url = `${appraisalService}/appraisal/propertyaccount/${pAccountID}/taxlimitationcalcstartyear`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyTaxLimitations(
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr },
) {
  let url = `${appraisalService}/prodigyappraisalnotices/taxlimitation/property/${pid}/${pYear}/${pVersion}/${pRollCorr}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePropertyTaxLimitations(
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr },
) {
  let url = `${appraisalService}/prodigyappraisalnotices/taxlimitation/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/calculateandupdate`;
  const { body } = await post(authenticationToken, url, {});
  return body;
}

export async function fetchPropertyTaxLimitation(
  { appraisalService },
  authenticationToken,
  { pTaxLimitationID },
) {
  let url = `${appraisalService}/prodigyappraisalnotices/propertyexemption/taxlimitation/${pTaxLimitationID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchCalculationHistory(
  { appraisalService },
  authenticationToken,
  { pTaxLimitationID },
) {
  let url = `${appraisalService}/prodigyappraisalnotices/propertyexemption/taxlimitation/${pTaxLimitationID}/calchistory`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function computeLimitation(
  { appraisalService },
  authenticationToken,
  { pExemptionID, payload },
) {
  let url = `${appraisalService}/prodigyappraisalnotices/taxlimitation/exemption/${pExemptionID}/calculateandupdate`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function computeLimitationCalcUpdateTaxingUnit(
  { appraisalService },
  authenticationToken,
  { pExemptionID, pTaxingUnitID, payload },
) {
  let url = `${appraisalService}/prodigyappraisalnotices/taxlimitation/exemption/${pExemptionID}/${pTaxingUnitID}/calculateandupdatetaxingunit`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function savePropertyTaxLimitation(
  { appraisalService },
  authenticationToken,
  { pTaxLimitationID, payload },
) {
  let url = `${appraisalService}/prodigyappraisalnotices/propertyexemption/taxlimitation/${pTaxLimitationID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function createPropertyTaxLimitation(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  let url = `${appraisalService}/prodigyappraisalnotices/propertyexemption/taxlimitations`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deletePropertyTaxLimitation(
  { appraisalService },
  authenticationToken,
  { pTaxLimitationID },
) {
  let url = `${appraisalService}/prodigyappraisalnotices/propertyexemption/taxlimitation/${pTaxLimitationID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateTaxLimitationCalcStartYear(
  { appraisalService },
  authenticationToken,
  { pAccountID, payload },
) {
  let url = `${appraisalService}/appraisal/propertyaccount/${pAccountID}/taxlimitationcalcstartyear`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchTaxLimitationHistory(
  { appraisalService },
  authenticationToken,
  { pAccountID, taxingUnitID },
) {
  let url = `${appraisalService}/appraisal/propertyaccount/${pAccountID}/${taxingUnitID}/taxlimitationhistory`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPublicPropertyAssociatedUsers(
  { publicService },
  authenticationToken,
  { pID },
) {
  let url = `${publicService}/public/property/${pID}/associatedusers`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyElectronicRequests(
  { publicService },
  authenticationToken,
  { pID },
) {
  let url = `${publicService}/appraisal/electronicdeliveryrequest/property/${pID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPublicUserAuthorizedEventForms(
  { publicService },
  authenticationToken,
  { userID, pID },
) {
  let url = `${publicService}/public/user/${userID}/${pID}/authorizedevents`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyYears(
  { appraisalService },
  authenticationToken,
  { pID },
) {
  const url = `${appraisalService}/appraisal/property/${pID}/years`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchOwnershipChainAllYears(
  { appraisalService },
  authenticationToken,
  { pID },
) {
  const url = `${appraisalService}/appraisal/property/${pID}/0/ownershipchain`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchOwnershipChainByYear(
  { appraisalService },
  authenticationToken,
  { pID, pYear },
) {
  console.log('api/property.js - getOwnershipChainByYear : ', pID, pYear);
  let url = `${appraisalService}/appraisal/property/${pID}/${pYear}/ownershipchain`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchNoticesPropertyEfile(
  { appraisalNoticeService },
  authenticationToken,
  { pID },
) {
  let url = `${appraisalNoticeService}/prodigyappraisalnotices/property/${pID}/efile`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateNoticesPropertyEfile(
  { appraisalNoticeService },
  authenticationToken,
  { pID, payload },
) {
  let url = `${appraisalNoticeService}/prodigyappraisalnotices/property/${pID}/efile`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function generateNoticesPropertyEfile(
  { appraisalNoticeService },
  authenticationToken,
  { pID },
) {
  let url = `${appraisalNoticeService}/prodigyappraisalnotices/property/${pID}/forcenewpin`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function fetchNoticesPropertyPublicUsers(
  { appraisalNoticeService },
  authenticationToken,
  { pID },
) {
  let url = `${appraisalNoticeService}/prodigyappraisalnotices/property/${pID}/associatedpublicusers`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchNoticesPropertyEfileHistory(
  { appraisalNoticeService },
  authenticationToken,
  { pID },
) {
  let url = `${appraisalNoticeService}/prodigyappraisalnotices/property/${pID}/efilehistory`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTimber78TaxingUnits(
  { appraisalService },
  authenticationToken,
  { pLandID },
) {
  let url = `${appraisalService}/appraisal/land/${pLandID}/tim78taxingunits`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateTimber78TaxingUnitsPricePerAcre(
  { appraisalService },
  authenticationToken,
  { pLandID, pTaxingUnitID, payload },
) {
  let url = `${appraisalService}/appraisal/land/${pLandID}/${pTaxingUnitID}/tim78taxingunit`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function copyTaxingUnitPricePerAcreFromAnotherProperty(
  { appraisalService },
  authenticationToken,
  { pLandID, fromPID },
) {
  let url = `${appraisalService}/appraisal/land/${pLandID}/tim78priceperacrefromproperty/${fromPID}`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function deleteMassProperties(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  let url = `${appraisalService}/appraisal/property/massinactivate`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function transferUDIOwnership(
  { appraisalService },
  authenticationToken,
  { accountId, payload },
) {
  let url = `${appraisalService}/appraisal/propertyaccount/${accountId}/transferudiownership`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchTransferUDIOwnershipStartYear(
  { appraisalService },
  authenticationToken,
  { accountId },
) {
  let url = `${appraisalService}/appraisal/propertyaccount/${accountId}/transferudiownership/startyear`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchImpDetailManagerCharacteristics(
  { appraisalService },
  authenticationToken,
  { pImprovementID },
) {
  let url = `${appraisalService}/appraisal/improvement/${pImprovementID}/improvementdetailmanager/characteristics`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateImpDetailManagerCharacteristics(
  { appraisalService },
  authenticationToken,
  { pImprovementID, payload },
) {
  let url = `${appraisalService}/appraisal/improvement/${pImprovementID}/improvementdetailmanager/characteristics`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchImpDetailManagerConditions(
  { appraisalService },
  authenticationToken,
  { pImprovementID },
) {
  let url = `${appraisalService}/appraisal/improvement/${pImprovementID}/improvementdetailmanager/condition`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateImpDetailManagerConditions(
  { appraisalService },
  authenticationToken,
  { pImprovementID, payload },
) {
  let url = `${appraisalService}/appraisal/improvement/${pImprovementID}/improvementdetailmanager/condition`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchImpDetailManagerNewValue(
  { appraisalService },
  authenticationToken,
  { pImprovementID },
) {
  let url = `${appraisalService}/appraisal/improvement/${pImprovementID}/improvementdetailmanager/newvalue`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateImpDetailManagerNewValue(
  { appraisalService },
  authenticationToken,
  { pImprovementID, payload },
) {
  let url = `${appraisalService}/appraisal/improvement/${pImprovementID}/improvementdetailmanager/newvalue`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchImpDetailManagerPricingModel(
  { appraisalService },
  authenticationToken,
  { pImprovementID },
) {
  let url = `${appraisalService}/appraisal/improvement/${pImprovementID}/improvementdetailmanager/pricingmodel`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateImpDetailManagerPricingModel(
  { appraisalService },
  authenticationToken,
  { pImprovementID, payload },
) {
  let url = `${appraisalService}/appraisal/improvement/${pImprovementID}/improvementdetailmanager/pricingmodel`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchImpDetailManagerAdjustment(
  { appraisalService },
  authenticationToken,
  { pImprovementID },
) {
  let url = `${appraisalService}/appraisal/improvement/${pImprovementID}/improvementdetailmanager/adjustment`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateImpDetailManagerAdjustment(
  { appraisalService },
  authenticationToken,
  { pImprovementID, payload },
) {
  const url = `${appraisalService}/appraisal/improvement/${pImprovementID}/improvementdetailmanager/adjustment`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function validatePIDList(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/property/validatepidlist`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchImprovementHistoryManager(
  { appraisalService },
  authenticationToken,
  { improvementId },
) {
  const url = `${appraisalService}/appraisal/improvement/${improvementId}/improvementhistorymanager`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateImprovementHistoryManager(
  { appraisalService },
  authenticationToken,
  { improvementId, priorYear_pImprovementID },
) {
  const url = `${appraisalService}/appraisal/improvement/${improvementId}/improvementhistorymanager`;
  const { body } = await put(authenticationToken, url, {
    priorYear_pImprovementID,
  });
  return body;
}

export async function clearImprovementHistoryManagerLink(
  { appraisalService },
  authenticationToken,
  { improvementId },
) {
  const url = `${appraisalService}/appraisal/improvement/${improvementId}/improvementhistorymanager/clearlink`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function fetchImprovementDetailHistoryManager(
  { appraisalService },
  authenticationToken,
  { improvementDetailId },
) {
  const url = `${appraisalService}/appraisal/improvementdetail/${improvementDetailId}/improvementdetailhistorymanager`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateImprovementDetailHistoryManager(
  { appraisalService },
  authenticationToken,
  { improvementDetailId, priorYear_pDetailID },
) {
  const url = `${appraisalService}/appraisal/improvementdetail/${improvementDetailId}/improvementdetailhistorymanager`;
  const { body } = await put(authenticationToken, url, { priorYear_pDetailID });
  return body;
}

export async function clearImprovementDetailHistoryManagerLink(
  { appraisalService },
  authenticationToken,
  { improvementDetailId },
) {
  const url = `${appraisalService}/appraisal/improvementdetail/${improvementDetailId}/improvementdetailhistorymanager/clearlink`;
  const { body } = await put(authenticationToken, url);
  return body;
}
